import React, { useEffect, useState, useRef, useCallback } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DrawerTemplate from "../../hoc/drawerTemplate";
import "./Vehicles.css";
import { vehicleData } from "./data";
import firebase from "../../config/firebase";
import { secondDatabase } from "../../config/firebase";
import BreakdownModal from "./BreakdownModal";
import MaintenanceModal from "./MaintenanceModal";
import VehicleForm from "./VehicleForm";
import TransferVehicle from "./TransferVehicle";
import {
  Button,
  Dialog,
  IconButton,
  Tooltip,
  Box,
  Typography,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as XLSX from "xlsx-js-style";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import ConsumptionModal from "./ConsumptionModal";
import { useHistory } from "react-router-dom";
import LoadingComponent from "../../components/LoadingComponent";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CalculateIcon from "@mui/icons-material/Calculate";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AssignmentIcon from "@mui/icons-material/Assignment";

const Vehicles = () => {
  const history = useHistory();
  useEffect(() => {
    const localStorageData = JSON.parse(localStorage.getItem("User"));
    const tempFirmId = localStorageData.firmId;
    setFirmId(tempFirmId);
  }, []);

  const exportToExcel = async (data, tableName, firmDataParam) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tableName);

    // Use the passed firmData parameter or the component state
    const firmDataToUse = firmDataParam || firmData;

    // Style definitions
    const titleStyle = {
      font: {
        name: "Calibri",
        size: 20,
        bold: true,
        color: { argb: "FF2C3E50" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" },
      },
      border: {
        top: { style: "thin", color: { argb: "FFFFFFFF" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFFFFFFF" } },
        right: { style: "thin", color: { argb: "FFFFFFFF" } },
      },
    };

    const subtitleStyle = {
      font: { name: "Calibri", size: 10, color: { argb: "FF7F8C8D" } },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" },
      },
    };

    const sectionHeaderStyle = {
      font: {
        name: "Calibri",
        size: 12,
        bold: true,
        color: { argb: "FF000000" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFDD34D" },
      },
      border: {
        top: { style: "thin", color: { argb: "FFE0E0E0" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFE0E0E0" } },
        right: { style: "thin", color: { argb: "FFE0E0E0" } },
      },
    };

    const columnHeaderStyle = {
      font: {
        name: "Calibri",
        size: 11,
        bold: true,
        color: { argb: "FF000000" },
      },
      alignment: { horizontal: "center", vertical: "middle", wrapText: true },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFDD34D" },
      },
      border: {
        top: { style: "thin", color: { argb: "FFE0E0E0" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFE0E0E0" } },
        right: { style: "thin", color: { argb: "FFE0E0E0" } },
      },
    };

    const cellStyle = {
      font: { name: "Calibri", size: 10, color: { argb: "FF2C3E50" } },
      alignment: { vertical: "middle", horizontal: "right", wrapText: true },
      border: {
        top: { style: "thin", color: { argb: "FFF0F0F0" } },
        bottom: { style: "thin", color: { argb: "FFF0F0F0" } },
        left: { style: "thin", color: { argb: "FFF0F0F0" } },
        right: { style: "thin", color: { argb: "FFF0F0F0" } },
      },
    };

    const numericCellStyle = {
      font: { name: "Calibri", size: 10, color: { argb: "FF2C3E50" } },
      alignment: { vertical: "middle", horizontal: "right" },
      border: {
        top: { style: "thin", color: { argb: "FFF0F0F0" } },
        bottom: { style: "thin", color: { argb: "FFF0F0F0" } },
        left: { style: "thin", color: { argb: "FFF0F0F0" } },
        right: { style: "thin", color: { argb: "FFF0F0F0" } },
      },
    }; // Helper function to convert string to number with value validation
    const toNumber = (value) => {
      if (
        value === "--" ||
        value === "" ||
        value === undefined ||
        value === null
      )
        return null;

      // Convert to number, accepting only digits, decimal point and negative sign
      const num = Number(String(value).replace(/[^\d.-]/g, ""));

      // Check if the result is a valid number and within reasonable bounds
      if (isNaN(num)) return null;

      // Check if value is unreasonably large or negative
      // For hours, fuel, and similar metrics, values should be reasonable
      if (num < 0 || num > 1000000) return null;

      return num;
    };

    if (tableName === "Daily Vehicle Report") {
      worksheet.mergeCells("A1:R1");
      worksheet.getCell("A1").value = tableName.toUpperCase();
      worksheet.getCell("A1").style = titleStyle;

      worksheet.mergeCells("A2:R2");
      worksheet.getCell(
        "A2"
      ).value = `Generated on ${new Date().toLocaleDateString()}`;
      worksheet.getCell("A2").style = subtitleStyle;

      worksheet.addRow([]);
      worksheet.addRow([]);

      const groupHeaders = [
        "VEHICLE",
        "",
        "",
        "",
        "READINGS",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "DIESEL",
        "",
        "",
        "",
        "PURPOSE",
      ];

      const headerRow = worksheet.addRow(groupHeaders);
      headerRow.eachCell((cell) => {
        cell.style = sectionHeaderStyle;
      });

      worksheet.mergeCells("A5:D5");
      worksheet.mergeCells("E5:L5");
      worksheet.mergeCells("M5:P5");
      worksheet.mergeCells("Q5:Q5");

      const columns = [
        "Project Name",
        "Type",
        "Number",
        "Chassis Number",
        "Start Reading",
        "End Reading",
        "Engine 1 Hours",
        "Engine 2 Start Reading",
        "Engine 2 End Reading",
        "Engine 2 Hours",
        "Start KM",
        "End KM",
        "Quantity (L)",
        "Amount (₹/L)",
        "Total Amount (₹)",
        "Efficiency (L/hr)",
        "Purpose",
      ];

      const columnRow = worksheet.addRow(columns);
      columnRow.eachCell((cell) => {
        cell.style = columnHeaderStyle;
      });

      data.forEach((item) => {
        const row = worksheet.addRow([
          item.projectName || "--",
          item.type || "--",
          item.number || "--",
          item.chassisNumber || "--",
          toNumber(item.startReading),
          toNumber(item.endReading),
          toNumber(item.hours),
          toNumber(item.engine2StartReading),
          toNumber(item.engine2EndReading),
          toNumber(item.engine2Hours),
          toNumber(item.kmsStartReading),
          toNumber(item.kmsEndReading),
          toNumber(item.quantity),
          toNumber(item.amount),
          toNumber(item.totalAmount),
          toNumber(item.efficiency),
          item.purpose || "--",
        ]);

        row.eachCell((cell, colNumber) => {
          if ([5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(colNumber)) {
            cell.style = numericCellStyle;
            cell.numFmt = "#,##0.00";
          } else {
            cell.style = cellStyle;
          }
        });
      });

      const columnWidths = [
        25, 15, 15, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 35,
      ];
      columnWidths.forEach((width, i) => {
        worksheet.getColumn(i + 1).width = width;
      });
    } else if (tableName === "Vehicle Information") {
      worksheet.mergeCells("A1:Z1");
      worksheet.getCell("A1").value = tableName.toUpperCase();
      worksheet.getCell("A1").style = titleStyle;

      worksheet.mergeCells("A2:Z2");
      worksheet.getCell(
        "A2"
      ).value = `Generated on ${new Date().toLocaleDateString()}`;
      worksheet.getCell("A2").style = subtitleStyle;

      worksheet.addRow([]);
      worksheet.addRow([]);

      const groupHeaders = [
        "VEHICLE DETAILS",
        "",
        "",
        "",
        "",
        "",
        "FUEL",
        "",
        "ENGINE HOURS",
        "",
        "",
        "KILOMETERS",
        "",
        "PERFORMANCE METRICS",
        "",
        "",
        "",
        "",
        "CUMULATIVE MOVEMENT",
        "",
        "",
        "PURCHASE",
        "",
        "INSURANCE",
        "",
        "",
        "PERMIT & FITNESS",
        "",
        "",
        "",
        "",
        "",
      ];

      const headerRow = worksheet.addRow(groupHeaders);
      headerRow.eachCell((cell) => {
        cell.style = sectionHeaderStyle;
      });

      worksheet.mergeCells("A5:F5");
      worksheet.mergeCells("G5:H5");
      worksheet.mergeCells("I5:K5");
      worksheet.mergeCells("L5:M5");
      worksheet.mergeCells("N5:R5");
      worksheet.mergeCells("S5:U5");
      worksheet.mergeCells("V5:W5");
      worksheet.mergeCells("X5:Z5");
      worksheet.mergeCells("AA5:AF5");

      const columns = [
        "Project Name",
        "Chassis Number",
        "Vehicle Number",
        "Type",
        "Make",
        "Model",
        "Total Fuel (L)",
        "Total Amount (₹)",
        "Engine 1 Hours",
        "Engine 2 Hours",
        "Total Hours",
        "Total Kms",
        "Avg (km/L)",
        "Avg Fuel (L/hr)",
        "Expected Fuel (L/hr)",
        "Efficiency Ratio",
        "Above 8hrs",
        "Below 8hrs",
        "Hours Worked",
        "Avg Fuel (L/hr)",
        "No Movement",
        "Month",
        "Year",
        "Start Date",
        "End Date",
        "Provider",
        "Permit Number",
        "Permit Range",
        "Valid Until",
        "FC Number",
        "FC Valid Until",
        "Road Tax Valid Until",
      ];

      const columnRow = worksheet.addRow(columns);
      columnRow.eachCell((cell) => {
        cell.style = columnHeaderStyle;
      });

      data.forEach((item) => {
        // Calculate additional metrics
        const engine1Hours = parseFloat(item.totalHoursWorked) || 0;
        const engine2Hours = parseFloat(item.engine2?.totalHoursWorked) || 0;
        const totalHours = engine1Hours + engine2Hours;

        // Validate total hours
        const validatedTotalHours =
          isNaN(totalHours) || totalHours < 0 || totalHours > 100000
            ? "--"
            : totalHours.toFixed(2);

        const fuelConsumed = parseFloat(item.totalDieselConsumed) || 0;
        const totalKms =
          parseFloat(item.totalKilometers || item.kmsTravelled) || 0;

        // Calculate dynamic values for the current date filter with validation
        let avgFuelPerHour = "--";
        if (totalHours > 0 && fuelConsumed > 0) {
          const calculatedRate = fuelConsumed / totalHours;
          avgFuelPerHour =
            calculatedRate > 0 && calculatedRate <= 100
              ? calculatedRate.toFixed(2)
              : "--";
        }

        let kmPerLiter = "--";
        if (fuelConsumed > 0 && totalKms > 0) {
          const calculatedKmPerLiter = totalKms / fuelConsumed;
          kmPerLiter =
            calculatedKmPerLiter > 0 && calculatedKmPerLiter <= 100
              ? calculatedKmPerLiter.toFixed(2)
              : "--";
        }

        // Calculate movement statistics for this vehicle based on date filters
        let above8Hours = 0;
        let below8Hours = 0;
        let noMovement = 0;

        // Get movement statistics directly from firmData respecting date filters
        if (firmDataToUse) {
          // Check if date filtering is active
          const isDateFilterActive =
            data.length > 0 && data[0].isDateFilterActive;

          // Loop through all projects to find relevant vehicle movements
          Object.keys(firmDataToUse).forEach((projectId) => {
            const vehicleMovements =
              firmDataToUse[projectId]?.vehicleMovementRecords || {};

            Object.entries(vehicleMovements).forEach(
              ([timestamp, movement]) => {
                // Apply date filter if active
                const date = new Date(parseInt(timestamp));
                const isWithinDateRange =
                  !isDateFilterActive ||
                  (date >= new Date(data[0].startDate) &&
                    date <= new Date(data[0].endDate));

                if (movement.tag === item.tag && isWithinDateRange) {
                  const hours = parseFloat(movement.hours) || 0;

                  if (hours >= 8) {
                    above8Hours++;
                  } else if (hours > 0) {
                    below8Hours++;
                  } else {
                    noMovement++;
                  }
                }
              }
            );
          });
        } // Get CUMULATIVE VALUES (not affected by date filter) - always use original total values
        // For cumulative values, we must use the original unfiltered vehicle data, not the date-filtered data
        // First, find the original vehicle data by tag or use the original data stored in item
        const originalVehicle =
          item.originalData ||
          vehiclesData.find((v) => v.tag === item.tag) ||
          item;

        const originalEngine1Hours =
          parseFloat(originalVehicle.totalHoursWorked) || 0;
        const originalEngine2Hours =
          parseFloat(originalVehicle.engine2?.totalHoursWorked) || 0;
        const originalTotalHours = originalEngine1Hours + originalEngine2Hours;

        // Validate cumulative hours to prevent unrealistic values
        let validatedCumulativeHours = "--";
        if (
          !isNaN(originalTotalHours) &&
          originalTotalHours >= 0 &&
          originalTotalHours <= 100000
        ) {
          validatedCumulativeHours = originalTotalHours.toFixed(2);
        }

        const originalTotalFuelConsumed =
          parseFloat(originalVehicle.totalDieselConsumed) || 0;

        // Calculate cumulative average fuel per hour with validation
        let cumulativeAvgFuelPerHour = "--";
        if (originalTotalHours > 0 && originalTotalFuelConsumed > 0) {
          const calculatedRate = originalTotalFuelConsumed / originalTotalHours;
          cumulativeAvgFuelPerHour =
            calculatedRate > 0 && calculatedRate <= 100
              ? calculatedRate.toFixed(2)
              : "--";
        }

        const row = worksheet.addRow([
          item.projectName || "--",
          item.chassisNumber || "--",
          item.vehicleNumber || item.number || "--",
          item.vehicleType || item.type || "--",
          item.make || "--",
          item.model || "--",
          toNumber(item.totalDieselConsumed),
          toNumber(item.amount),
          toNumber(item.totalHoursWorked),
          toNumber(item.engine2?.totalHoursWorked),
          validatedTotalHours === "--" ? "--" : toNumber(validatedTotalHours),
          toNumber(item.totalKilometers || item.kmsTravelled),
          kmPerLiter === "--" ? "--" : toNumber(kmPerLiter),
          avgFuelPerHour === "--" ? "--" : toNumber(avgFuelPerHour),
          toNumber(getExpectedMileage(item.model)),
          toNumber(
            calculateEfficiencyRatio(
              avgFuelPerHour,
              getExpectedMileage(item.model)
            )
          ),
          above8Hours > 0 ? above8Hours : "--",
          below8Hours > 0 ? below8Hours : "--",
          validatedCumulativeHours === "--"
            ? "--"
            : toNumber(validatedCumulativeHours),
          cumulativeAvgFuelPerHour === "--"
            ? "--"
            : toNumber(cumulativeAvgFuelPerHour),
          noMovement > 0 ? noMovement : "--",
          item.monthOfPurchase || "--",
          item.yearOfPurchase || "--",
          item.insuranceStartDate
            ? new Date(item.insuranceStartDate).toLocaleDateString()
            : "--",
          item.insuranceEndDate
            ? new Date(item.insuranceEndDate).toLocaleDateString()
            : "--",
          item.insuranceProvider || "--",
          item.permitNo || "--",
          item.permitRange || "--",
          item.permitValidUpto
            ? new Date(item.permitValidUpto).toLocaleDateString()
            : "--",
          item.fitnessCertificateNo || "--",
          item.fcValidUpto
            ? new Date(item.fcValidUpto).toLocaleDateString()
            : "--",
          item.roadTaxValidUpto
            ? new Date(item.roadTaxValidUpto).toLocaleDateString()
            : "--",
        ]);

        row.eachCell((cell, colNumber) => {
          if (
            [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].includes(
              colNumber
            )
          ) {
            cell.style = numericCellStyle;
            cell.numFmt = "#,##0.00";
          } else {
            cell.style = cellStyle;
          }
        });
      });

      const columnWidths = Array(32).fill(18);
      columnWidths[0] = 30; // Project name
      columnWidths[1] = 25; // Chassis number
      columnWidths.forEach((width, i) => {
        worksheet.getColumn(i + 1).width = width;
      });
    } else if (tableName === "Service Schedule") {
      worksheet.mergeCells("A1:O1");
      worksheet.getCell("A1").value = tableName.toUpperCase();
      worksheet.getCell("A1").style = titleStyle;

      worksheet.mergeCells("A2:O2");
      worksheet.getCell(
        "A2"
      ).value = `Generated on ${new Date().toLocaleDateString()}`;
      worksheet.getCell("A2").style = subtitleStyle;

      worksheet.addRow([]);
      worksheet.addRow([]);

      const groupHeaders = [
        "VEHICLE",
        "",
        "",
        "",
        "",
        "",
        "SERVICE DETAILS",
        "",
        "",
        "SERVICE HISTORY",
        "",
        "",
        "BREAKDOWN",
        "",
        "TOTAL COST",
      ];

      const headerRow = worksheet.addRow(groupHeaders);
      headerRow.eachCell((cell) => {
        cell.style = sectionHeaderStyle;
      });

      worksheet.mergeCells("A5:F5");
      worksheet.mergeCells("G5:I5");
      worksheet.mergeCells("J5:L5");
      worksheet.mergeCells("M5:N5");
      worksheet.mergeCells("O5:O5");

      const columns = [
        "Project Name",
        "Chassis Number",
        "Type",
        "Number",
        "Hours",
        "Fuel Consumed",
        "Next Service In",
        "Last Service Date",
        "Description",
        "Service Cost",
        "Cycle Type",
        "Maintenance Cost",
        "No of Breakdowns",
        "Breakdown Cost",
        "Total Cost",
      ];

      const columnRow = worksheet.addRow(columns);
      columnRow.eachCell((cell) => {
        cell.style = columnHeaderStyle;
      });

      data.forEach((item) => {
        const row = worksheet.addRow([
          item.projectName || "--",
          item.chassisNumber || "--",
          item.type || "--",
          item.number || "--",
          toNumber(item.hours),
          toNumber(item.fuelConsumed),
          item.nextServiceIn || "--",
          item.lastServiceDate || "--",
          item.serviceDescription || "--",
          toNumber(item.totalServiceCost),
          item.cycleType || "--",
          toNumber(item.maintenanceCost),
          toNumber(item.numberOfBreakdowns?.total),
          toNumber(item.totalBreakdownCost),
          toNumber(
            Number(item.totalServiceCost) + Number(item.totalBreakdownCost)
          ),
        ]);

        row.eachCell((cell, colNumber) => {
          if ([5, 6, 10, 12, 13, 14, 15].includes(colNumber)) {
            cell.style = numericCellStyle;
            cell.numFmt = "#,##0.00";
          } else {
            cell.style = cellStyle;
          }
        });
      });

      const columnWidths = [
        30, 25, 20, 20, 15, 15, 15, 15, 35, 15, 15, 15, 15, 15, 15,
      ];
      columnWidths.forEach((width, i) => {
        worksheet.getColumn(i + 1).width = width;
      });
    }

    // Set print area and page setup
    worksheet.pageSetup.printArea = worksheet.dimensions.address;
    worksheet.pageSetup.fitToPage = true;
    worksheet.pageSetup.fitToWidth = 1;
    worksheet.pageSetup.orientation = "landscape";
    worksheet.pageSetup.margins = {
      left: 0.25,
      right: 0.25,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };

    // Enable filters for all columns
    worksheet.autoFilter = {
      from: {
        row: 6,
        column: 1,
      },
      to: {
        row: worksheet.rowCount,
        column: worksheet.columnCount,
      },
    };

    // Freeze panes
    worksheet.views = [
      {
        state: "frozen",
        xSplit: 0,
        ySplit: 6,
        topLeftCell: "A7",
        activeCell: "A7",
      },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Format date and save file
    const formattedDate = new Date()
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");
    const filename = `${tableName}_${formattedDate}.xlsx`;
    saveAs(blob, filename);
  };
  const renderExportButton = () => (
    <button
      onClick={() => {
        let data;
        let tableName;

        switch (activeTab) {
          case "daily":
            // Create daily report data directly here
            const dailyData = [];

            if (firmData) {
              Object.keys(firmData).forEach((projectId) => {
                const projectData = projects.find(
                  (p) => p.projectID === projectId
                );
                const projectName = projectData
                  ? projectData.projectName
                  : "--";

                const vehicleMovements =
                  firmData[projectId]?.vehicleMovementRecords || {};

                Object.entries(vehicleMovements).forEach(
                  ([timestamp, movement]) => {
                    const date = new Date(parseInt(timestamp));

                    if (date >= startDate && date <= endDate) {
                      const hours = parseFloat(movement.hours) || 0;
                      const meetsTimeFilter =
                        timeFilter === "all"
                          ? true
                          : timeFilter === "< 8 hours"
                          ? hours < 8
                          : false;

                      if (meetsTimeFilter) {
                        const dieselConsumed =
                          parseFloat(movement.quantity) || 0;
                        const matchingVehicle = vehiclesData.find(
                          (v) => v.tag === movement.tag
                        );
                        dailyData.push({
                          projectName: projectName,
                          by: movement.by || "--",
                          date: date,
                          type: matchingVehicle?.vehicleType || "--",
                          number: matchingVehicle?.vehicleNumber || "--",
                          chassisNumber: matchingVehicle?.chassisNumber || "--",
                          startReading: movement.startReading || "--",
                          endReading: movement.endReading || "--",
                          hours: movement.hours || "--",
                          engine2StartReading:
                            movement.engine2StartReading || "--",
                          engine2EndReading: movement.engine2EndReading || "--",
                          engine2Hours: movement.engine2Hours || "--",
                          kmsStartReading: movement.kmsStartReading || "--",
                          kmsEndReading: movement.kmsEndReading || "--",
                          kmsTravelled: movement.kmsTravelled || "--",
                          fuelConsumed: dieselConsumed.toFixed(2),
                          amount: movement.amount || "--",
                          totalAmount: movement.amount
                            ? (dieselConsumed * movement.amount).toFixed(2)
                            : "--",
                          purpose: movement.purpose || "--",
                          quantity: movement.quantity || "--",
                        });
                      }
                    }
                  }
                );
              });
            }

            // Sort by date descending
            dailyData.sort((a, b) => b.date - a.date);
            data = filterData(dailyData);
            tableName = "Daily Vehicle Report";
            break;

          case "vehicle":
            // Process vehicle data with date filtering applied
            const isDateFilterActive = startDate && endDate;

            // Create processed data with all necessary metrics calculated
            const processedVehicleData = vehiclesData.map((item) => {
              // Calculate date-filtered metrics if date filtering is active
              const metrics = isDateFilterActive
                ? calculateDateFilteredMetrics(item, startDate, endDate)
                : item;

              // Calculate mileage (L/hr)
              let mileage = "--";
              const totalDieselConsumed = isDateFilterActive
                ? parseFloat(metrics.totalDieselConsumed)
                : parseFloat(item.totalDieselConsumed);
              const totalHoursWorked = isDateFilterActive
                ? parseFloat(metrics.totalHoursWorked)
                : parseFloat(item.totalHoursWorked);

              if (
                !isNaN(totalDieselConsumed) &&
                !isNaN(totalHoursWorked) &&
                totalHoursWorked > 0
              ) {
                mileage = (totalDieselConsumed / totalHoursWorked).toFixed(2);
              }

              // Get expected mileage
              const expectedMileage = getExpectedMileage(item.model);

              // Calculate efficiency ratio
              const efficiencyRatio = calculateEfficiencyRatio(
                mileage,
                expectedMileage
              ); // Create a copy of the original item for reference (to be used for cumulative metrics)
              const originalItem = { ...item };

              return {
                ...item,
                // For export, use the same processed values that the table displays for filtered metrics
                mileage: mileage,
                expectedMileage: expectedMileage,
                efficiencyRatio: efficiencyRatio,
                totalKilometers: isDateFilterActive
                  ? metrics.totalKilometers
                  : item.totalKilometers || item.kmsTravelled || 0,
                totalDieselConsumed: isDateFilterActive
                  ? metrics.totalDieselConsumed
                  : item.totalDieselConsumed || 0,
                amount: isDateFilterActive ? metrics.amount : item.amount || 0,
                totalHoursWorked: isDateFilterActive
                  ? metrics.totalHoursWorked
                  : item.totalHoursWorked || 0,
                engine2: {
                  ...item.engine2,
                  totalHoursWorked: isDateFilterActive
                    ? metrics.engine2?.totalHoursWorked || 0
                    : item.engine2?.totalHoursWorked || 0,
                },
                // Store the original unfiltered values for cumulative metrics
                originalData: originalItem,
              };
            });

            data = filterData(processedVehicleData);
            tableName = "Vehicle Information";
            break;

          case "service":
            data = filterData(maintenanceData);
            tableName = "Service Schedule";
            break;
        }

        exportToExcel(data, tableName, firmData);
      }}
      className="export-button"
      style={{
        backgroundColor: "#fdd34d",
        color: "black",
        border: "none",
        borderRadius: "8px",
        padding: "10px 18px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        outline: "none",
        transform: "scale(1)",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "scale(1.05)";
        e.target.style.boxShadow = "0 6px 8px rgba(0, 0, 0, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      Export to Excel
    </button>
  );
  // State management
  const [selectedChassisNumbers, setSelectedChassisNumbers] = useState([]);
  const filterModalRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("daily");
  const [searchQuery, setSearchQuery] = useState("");
  const [timeFilter, setTimeFilter] = useState("all");
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    return sevenDaysAgo;
  });
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [breakdownModalOpen, setBreakdownModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [maintenanceModalOpen, setMaintenanceModalOpen] = useState(false);
  const [endDate, setEndDate] = useState(() => new Date());
  const [vehiclesData, setVehiclesData] = useState([]);
  const [firmData, setFirmData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [firmDetailsId, setFirmDetailsId] = useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [maintenanceData, setMaintenanceData] = useState([]);
  const [selectedBreakdowns, setSelectedBreakdowns] = useState(null);
  const [firmId, setFirmId] = useState("");
  const [recalculateDialogOpen, setRecalculateDialogOpen] = useState(false);
  // New states for vehicle management
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [currentProject, setCurrentProject] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [actionLoading, setActionLoading] = useState(false);
  const [consumptionHistoryData, setConsumptionHistoryData] = useState(null);
  // Add these utility functions
  const getUniqueChassisNumbers = () => {
    return [...new Set(vehiclesData.map((item) => item.chassisNumber))].filter(
      Boolean
    );
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterModalRef.current &&
        !filterModalRef.current.contains(event.target)
      ) {
        setIsFilterOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterModalRef, setIsFilterOpen]);
  // Vehicles.js
  const handleSubmit = async (vehicleData) => {
    setActionLoading(true);
    try {
      // Get the firmDetailsId from the local storage
      const localStorageData = JSON.parse(localStorage.getItem("User"));
      const firmDetailsID = firmDetailsId;

      // Generate timestamp for key
      const timestamp = new Date().getTime().toString(); // Convert to string to ensure consistency

      // Format the data
      const formattedData = {
        ...vehicleData,
        timestamp: timestamp,
        id: timestamp,
        tag: vehicleData.tag,
        transferredFromAnotherSite: false,
        transferred: false,
        sos: false,
      };

      // Clean up unnecessary fields

      // Create an update object
      const updates = {};
      updates[
        `${firmDetailsID}/${vehicleData.projectId}/vehicles/${timestamp}`
      ] = formattedData;

      // Update database
      await secondDatabase.ref().update(updates);

      setSnackbar({
        open: true,
        message: "Vehicle added successfully",
        severity: "success",
      });

      setIsAddModalOpen(false);
      fetchVehicles();
    } catch (error) {
      console.error("Error adding vehicle:", error);
      setSnackbar({
        open: true,
        message: `Error adding vehicle: ${error.message}`,
        severity: "error",
      });
    }
    setActionLoading(false);
  };
  // In Vehicles.js
  // Add this function in Vehicles.js
  const getExistingVehicleTypes = () => {
    return [...new Set(vehiclesData.map((v) => v.vehicleType))]
      .filter(Boolean) // Remove null/undefined/empty values
      .sort(); // Sort alphabetically
  };
  const [isConsumptionModalOpen, setIsConsumptionModalOpen] = useState(false);
  const handleAddConsumption = async (consumptionData) => {
    setActionLoading(true);
    try {
      // Update path to match vehicleMovementRecords structure
      const path = `${firmDetailsId}/${consumptionData.projectId}/vehicleMovementRecords/${consumptionData.timestamp}`;

      const entryData = {
        itemKey: consumptionData.itemKey,
        purpose: consumptionData.purpose,
        quantity: consumptionData.quantity,
        tag: consumptionData.tag,
        timestamp: consumptionData.timestamp,
        amount: consumptionData.amount,
        vehicleId: consumptionData.vehicleId,
        startReading: consumptionData.startReading || "",
        endReading: consumptionData.endReading || "",
        hours: consumptionData.hours || "0",
        engine2StartReading: consumptionData.engine2StartReading || "",
        engine2EndReading: consumptionData.engine2EndReading || "",
        engine2Hours: consumptionData.engine2Hours || "0",
        kmsStartReading: consumptionData.kmsStartReading || "",
        kmsEndReading: consumptionData.kmsEndReading || "",
        kmsTravelled: consumptionData.kmsTravelled || "0",
      };

      await secondDatabase.ref(path).set(entryData);
      await updateVehicleInformation(consumptionData, false);

      setSnackbar({
        open: true,
        message: "Vehicle usage added successfully",
        severity: "success",
      });

      fetchVehicles();
    } catch (error) {
      console.error("Error adding consumption:", error);
      setSnackbar({
        open: true,
        message: `Error adding usage: ${error.message}`,
        severity: "error",
      });
    }
    setActionLoading(false);
  };
  const updateVehicleInformation = async (
    consumptionData,
    isEditing = false
  ) => {
    try {
      const vehicleByTag = vehiclesData.find(
        (v) => v.tag === consumptionData.tag
      );
      if (!vehicleByTag) {
        console.error("Vehicle not found with tag:", consumptionData.tag);
        return false;
      }

      const updates = {};
      const vehiclePath = `${firmDetailsId}/${vehicleByTag.projectId}/vehicles/${vehicleByTag.id}`;

      // Calculate values for update
      const hoursWorked = parseFloat(consumptionData.hours) || 0;
      const kmsTravelled = parseFloat(consumptionData.kmsTravelled) || 0;
      const dieselConsumed = parseFloat(consumptionData.quantity) || 0;
      const engine2Hours = parseFloat(consumptionData.engine2Hours) || 0;

      // For editing, subtract old amount and add new amount
      // For new entries, just add the new amount
      let amountChange;
      if (isEditing) {
        // oldAmount and newAmount are passed from handleEditConsumption
        amountChange = consumptionData.newAmount - consumptionData.oldAmount;
      } else {
        amountChange = dieselConsumed * parseFloat(consumptionData.amount) || 0;
      }

      // Create updated vehicle object - ensuring all values are stored as numbers, not strings
      const updatedVehicle = {
        ...vehicleByTag,
        totalHoursWorked: Number(
          (parseFloat(vehicleByTag.totalHoursWorked) || 0) + hoursWorked
        ),
        totalKilometers: Number(
          (parseFloat(vehicleByTag.totalKilometers) || 0) + kmsTravelled
        ),
        totalDieselConsumed: Number(
          (parseFloat(vehicleByTag.totalDieselConsumed) || 0) + dieselConsumed
        ),
        amount: Number((parseFloat(vehicleByTag.amount) || 0) + amountChange),
      };

      // Handle engine2 if it exists
      if (vehicleByTag.engine2 && engine2Hours > 0) {
        updatedVehicle.engine2 = {
          ...vehicleByTag.engine2,
          totalHoursWorked: Number(
            (parseFloat(vehicleByTag.engine2?.totalHoursWorked) || 0) +
              engine2Hours
          ),
          totalDieselConsumed: Number(
            (parseFloat(vehicleByTag.engine2?.totalDieselConsumed) || 0) +
              dieselConsumed
          ),
        };
      }

      updates[vehiclePath] = updatedVehicle;
      await secondDatabase.ref().update(updates);
      return true;
    } catch (error) {
      console.error("Error updating vehicle information:", error);
      return false;
    }
  };
  const handleEditConsumption = async (newEntry) => {
    setActionLoading(true);
    try {
      // Update path to match vehicleMovementRecords structure
      const path = `${firmDetailsId}/${newEntry.projectId}/vehicleMovementRecords/${newEntry.timestamp}`;

      // Fetch old entry to calculate differences
      const oldEntrySnapshot = await secondDatabase.ref(path).once("value");
      const oldEntry = oldEntrySnapshot.val();

      // Calculate old and new amounts
      const oldAmount =
        parseFloat(oldEntry.quantity || 0) * parseFloat(oldEntry.amount || 0);
      const newAmount =
        parseFloat(newEntry.quantity || 0) * parseFloat(newEntry.amount || 0);

      const diffData = {
        ...newEntry,
        hours:
          parseFloat(newEntry.hours || 0) - parseFloat(oldEntry.hours || 0),
        kmsTravelled:
          parseFloat(newEntry.kmsTravelled || 0) -
          parseFloat(oldEntry.kmsTravelled || 0),
        quantity:
          parseFloat(newEntry.quantity || 0) -
          parseFloat(oldEntry.quantity || 0),
        engine2Hours:
          parseFloat(newEntry.engine2Hours || 0) -
          parseFloat(oldEntry.engine2Hours || 0),
        oldAmount: oldAmount,
        newAmount: newAmount,
      };

      // Update entry
      await secondDatabase.ref(path).set(newEntry);
      await updateVehicleInformation(diffData, true);

      setSnackbar({
        open: true,
        message: "Entry updated successfully",
        severity: "success",
      });

      fetchVehicles();
    } catch (error) {
      console.error("Error updating entry:", error);
      setSnackbar({
        open: true,
        message: "Error updating entry",
        severity: "error",
      });
    }
    setActionLoading(false);
  };
  const handleDeleteConsumption = async (entry) => {
    try {
      // Update path to match vehicleMovementRecords structure
      const path = `${firmDetailsId}/${entry.projectId}/vehicleMovementRecords/${entry.timestamp}`;

      // Create negative values for updating vehicle information
      const deleteData = {
        ...entry,
        hours: -parseFloat(entry.hours || 0),
        kmsTravelled: -parseFloat(entry.kmsTravelled || 0),
        quantity: -parseFloat(entry.quantity || 0),
        engine2Hours: -parseFloat(entry.engine2Hours || 0),
      };

      // Update vehicle information first
      await updateVehicleInformation(deleteData, true);

      // Then delete the entry
      await secondDatabase.ref(path).remove();

      setSnackbar({
        open: true,
        message: "Entry deleted successfully",
        severity: "success",
      });

      fetchVehicles();
    } catch (error) {
      console.error("Error deleting entry:", error);
      setSnackbar({
        open: true,
        message: "Error deleting entry",
        severity: "error",
      });
    }
  };

  const handleEdit = async (vehicleData) => {
    setActionLoading(true);
    try {
      const localStorageData = JSON.parse(localStorage.getItem("User"));
      const firmDetailsID = firmDetailsId;

      // Get the original timestamp that serves as the vehicle's key
      const timestamp = selectedVehicle.id;

      // Format the data while preserving the original timestamp and status
      const formattedData = {
        ...vehicleData,
        id: timestamp, // Keep the original ID
        timestamp: timestamp, // Keep the original timestamp
        transferredFromAnotherSite:
          selectedVehicle.transferredFromAnotherSite || false,
        transferred: selectedVehicle.transferred || false,
        sos: selectedVehicle.sos || false,
        projectId: selectedVehicle.projectId, // Keep the original project ID for editing
      };

      // Reference the exact vehicle node using the timestamp
      const vehicleRef = secondDatabase.ref(
        `${firmDetailsID}/${selectedVehicle.projectId}/vehicles/${timestamp}`
      );

      // Update the existing vehicle data
      await vehicleRef.update(formattedData);

      setSnackbar({
        open: true,
        message: "Vehicle updated successfully",
        severity: "success",
      });

      setIsEditModalOpen(false);
      setSelectedVehicle(null);
      fetchVehicles(); // Refresh the list
    } catch (error) {
      console.error("Error updating vehicle:", error);
      setSnackbar({
        open: true,
        message: `Error updating vehicle: ${error.message}`,
        severity: "error",
      });
    }
    setActionLoading(false);
  };

  const handleTransfer = async (transferData) => {
    setActionLoading(true);
    try {
      const localStorageData = JSON.parse(localStorage.getItem("User"));
      const firmDetailsID = firmDetailsId;

      // Get current timestamp as string
      const timestamp = selectedVehicle.id;

      // Create the vehicle data for the new project
      const vehicleData = {
        ...selectedVehicle,
        timestamp: timestamp,
        id: timestamp,
        transferredFromAnotherSite: true,
        transferred: false,
        transferredFrom: selectedVehicle.projectId,
        transferTimestamp: new Date().getTime().toString(),
        transferNotes: transferData.notes,
        projectId: transferData.destinationProjectId,
      };

      const tempVehicleData = {
        ...selectedVehicle,
        transferred: true,
        id: timestamp,
        transferredTo: transferData.destinationProjectId,
        transferTimestamp: new Date().getTime().toString(),
        transferNotes: transferData.notes,
      };

      // Create updates object for atomic operation
      const updates = {};

      // Add transferred to current project
      updates[
        `${firmDetailsID}/${selectedVehicle.projectId}/vehicles/${timestamp}`
      ] = tempVehicleData;

      // Add to new project with same timestamp key
      updates[
        `${firmDetailsID}/${transferData.destinationProjectId}/vehicles/${timestamp}`
      ] = vehicleData;

      // Execute both operations atomically
      await secondDatabase.ref().update(updates);

      setSnackbar({
        open: true,
        message: "Vehicle transferred successfully",
        severity: "success",
      });

      setIsTransferModalOpen(false);
      setSelectedVehicle(null);
      fetchVehicles();
    } catch (error) {
      console.error("Error transferring vehicle:", error);
      setSnackbar({
        open: true,
        message: `Error transferring vehicle: ${error.message}`,
        severity: "error",
      });
    }
    setActionLoading(false);
  };

  // Add management buttons to your existing render method
  // First, add these helper functions to count vehicles for each filter option
  const countVehiclesByProject = (projectName) => {
    // Start with all vehicles, excluding transferred ones
    let filteredVehicles = vehiclesData.filter(
      (vehicle) => !vehicle.transferred
    );

    // Apply other active filters
    if (selectedVehicleTypes.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedVehicleTypes.includes(vehicle.vehicleType || vehicle.type)
      );
    }

    if (selectedChassisNumbers.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedChassisNumbers.includes(vehicle.chassisNumber)
      );
    }

    // Count non-transferred vehicles matching this project
    return filteredVehicles.filter(
      (vehicle) => vehicle.projectName === projectName
    ).length;
  };
  const countVehiclesByType = (vehicleType) => {
    // Start with all vehicles, excluding transferred ones
    let filteredVehicles = vehiclesData.filter(
      (vehicle) => !vehicle.transferred
    );

    // Apply other active filters
    if (selectedProjects.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedProjects.includes(vehicle.projectName)
      );
    }

    if (selectedChassisNumbers.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedChassisNumbers.includes(vehicle.chassisNumber)
      );
    }

    // Count vehicles matching this type
    return filteredVehicles.filter(
      (vehicle) => (vehicle.vehicleType || vehicle.type) === vehicleType
    ).length;
  };

  const recalculateVehicleMetrics = async () => {
    if (!firmData || !firmDetailsId) return;

    setActionLoading(true);

    try {
      // Helper function to safely parse numeric values
      const safeParseFloat = (value) => {
        // Return 0 for null, undefined, empty strings, or "-"
        if (!value || value === "-" || value === "--") return 0;

        // Convert to string for checking
        const stringValue = String(value);

        // Check if value contains any special characters (anything that's not a digit, decimal point, or minus sign)
        if (/[^\d.-]/.test(stringValue)) {
          return 0; // Return 0 if any special characters exist
        }

        // Parse the value directly without cleaning
        const parsedValue = parseFloat(stringValue);

        // Check if the result is a valid number
        if (isNaN(parsedValue)) return 0;

        // Check for unreasonably large values (basic sanity check)
        if (parsedValue < 0 || parsedValue > 1000000) return 0;

        return parsedValue;
      };

      // First, identify and fix records with inconsistent readings
      const readingUpdates = {};
      let inconsistencyCount = 0;

      // Process all projects to find inconsistent readings
      Object.keys(firmData).forEach((projectId) => {
        const vehicleMovements =
          firmData[projectId]?.vehicleMovementRecords || {};

        // Check each vehicle movement record for inconsistencies
        Object.entries(vehicleMovements).forEach(([timestamp, movement]) => {
          let hasUpdates = false;
          const updatedMovement = { ...movement };

          // Check Engine 1 readings
          const startReading = safeParseFloat(movement.startReading);
          const endReading = safeParseFloat(movement.endReading);

          if (startReading > 0 && endReading === 0) {
            updatedMovement.endReading = movement.startReading;
            updatedMovement.hours = "0"; // Since start and end are the same, hours would be 0
            hasUpdates = true;
          }

          // Check Engine 2 readings
          const engine2StartReading = safeParseFloat(
            movement.engine2StartReading
          );
          const engine2EndReading = safeParseFloat(movement.engine2EndReading);

          if (engine2StartReading > 0 && engine2EndReading === 0) {
            updatedMovement.engine2EndReading = movement.engine2StartReading;
            updatedMovement.engine2Hours = "0"; // Since start and end are the same, hours would be 0
            hasUpdates = true;
          }

          // Check Kilometer readings
          const kmsStartReading = safeParseFloat(movement.kmsStartReading);
          const kmsEndReading = safeParseFloat(movement.kmsEndReading);

          if (kmsStartReading > 0 && kmsEndReading === 0) {
            updatedMovement.kmsEndReading = movement.kmsStartReading;
            updatedMovement.kmsTravelled = "0"; // Since start and end are the same, km traveled would be 0
            hasUpdates = true;
          }

          // If any inconsistencies were found, add to updates
          if (hasUpdates) {
            readingUpdates[
              `${firmDetailsId}/${projectId}/vehicleMovementRecords/${timestamp}`
            ] = updatedMovement;
            inconsistencyCount++;
          }
        });
      });

      // Apply the reading updates if there are any
      if (Object.keys(readingUpdates).length > 0) {
        await secondDatabase.ref().update(readingUpdates);
      }

      // Continue with original functionality: Create a map to store aggregated metrics for each vehicle tag
      const vehicleMetrics = {};

      // Process all projects
      Object.keys(firmData).forEach((projectId) => {
        const vehicleMovements =
          firmData[projectId]?.vehicleMovementRecords || {};

        // Process all vehicle movement records
        Object.entries(vehicleMovements).forEach(([timestamp, movement]) => {
          const tag = movement.tag;
          if (!tag) return;

          // Initialize metrics for this vehicle if not already done
          if (!vehicleMetrics[tag]) {
            vehicleMetrics[tag] = {
              totalHoursWorked: 0,
              totalDieselConsumed: 0,
              totalKilometers: 0,
              amount: 0,
              engine2: {
                totalHoursWorked: 0,
              },
            };
          }

          // Safely parse all values
          const hours = safeParseFloat(movement.hours);
          const dieselConsumed = safeParseFloat(movement.quantity);
          const kmsTravelled = safeParseFloat(movement.kmsTravelled);
          const engine2Hours = safeParseFloat(movement.engine2Hours);
          const amount = safeParseFloat(movement.amount);

          // Skip calculations with invalid values
          if (
            hours < 0 ||
            dieselConsumed < 0 ||
            kmsTravelled < 0 ||
            engine2Hours < 0
          ) {
            return;
          }

          // Ensure we're adding numbers to numbers, not concatenating strings
          vehicleMetrics[tag].totalHoursWorked =
            Number(vehicleMetrics[tag].totalHoursWorked) + hours;
          vehicleMetrics[tag].totalDieselConsumed =
            Number(vehicleMetrics[tag].totalDieselConsumed) + dieselConsumed;
          vehicleMetrics[tag].totalKilometers =
            Number(vehicleMetrics[tag].totalKilometers) + kmsTravelled;

          // Calculate amount (quantity * rate)
          if (dieselConsumed > 0 && amount > 0) {
            vehicleMetrics[tag].amount =
              Number(vehicleMetrics[tag].amount) + dieselConsumed * amount;
          }

          // If engine2 hours exists, update its metrics
          if (engine2Hours > 0) {
            vehicleMetrics[tag].engine2.totalHoursWorked =
              Number(vehicleMetrics[tag].engine2.totalHoursWorked) +
              engine2Hours;
          }
        });
      });

      // Update all vehicles in the database
      const updates = {};
      let updatedCount = 0;
      let skippedCount = 0;

      // Process each project to find and update vehicles
      for (const projectId of Object.keys(firmData)) {
        const vehicles = firmData[projectId]?.vehicles || {};

        for (const [vehicleId, vehicle] of Object.entries(vehicles)) {
          const tag = vehicle.tag;
          if (!tag || !vehicleMetrics[tag]) {
            skippedCount++;
            continue;
          }

          // Prepare the update for this vehicle - store as numbers instead of strings
          const updatedVehicle = {
            ...vehicle,
            totalHoursWorked: Number(
              vehicleMetrics[tag].totalHoursWorked.toFixed(2)
            ),
            totalDieselConsumed: Number(
              vehicleMetrics[tag].totalDieselConsumed.toFixed(2)
            ),
            totalKilometers: Number(
              vehicleMetrics[tag].totalKilometers.toFixed(2)
            ),
            amount: Number(vehicleMetrics[tag].amount.toFixed(2)),
          };

          // Update engine2 metrics if the vehicle has an engine2
          if (vehicle.engine2) {
            updatedVehicle.engine2 = {
              ...vehicle.engine2,
              totalHoursWorked: Number(
                vehicleMetrics[tag].engine2.totalHoursWorked.toFixed(2)
              ),
            };
          }

          // Add to the batch update
          updates[`${firmDetailsId}/${projectId}/vehicles/${vehicleId}`] =
            updatedVehicle;
          updatedCount++;
        }
      }

      // Execute the batch update if there are any changes
      if (Object.keys(updates).length > 0) {
        await secondDatabase.ref().update(updates);

        // Show success notification with both updates
        setSnackbar({
          open: true,
          message: `Fixed ${inconsistencyCount} inconsistent readings and recalculated metrics for ${updatedCount} vehicles${
            skippedCount > 0 ? ` (${skippedCount} skipped)` : ""
          }`,
          severity: "success",
        });
      } else {
        // Still notify about fixing inconsistencies if any were found
        if (inconsistencyCount > 0) {
          setSnackbar({
            open: true,
            message: `Fixed ${inconsistencyCount} inconsistent readings`,
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: "No updates needed - all data is consistent",
            severity: "info",
          });
        }
      }
    } catch (error) {
      console.error("Error updating vehicle metrics:", error);
      setSnackbar({
        open: true,
        message: `Error recalculating vehicle metrics: ${error.message}`,
        severity: "error",
      });
    } finally {
      setActionLoading(false);
    }
  };

  const renderRecalculateButton = () => (
    <button
      onClick={() => setRecalculateDialogOpen(true)}
      className="recalculate-button"
      disabled={actionLoading}
      style={{
        backgroundColor: "#fdd34d",
        color: "black",
        border: "none",
        borderRadius: "8px",
        padding: "10px 18px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        outline: "none",
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = "scale(1.05)";
        e.target.style.boxShadow = "0 6px 8px rgba(0, 0, 0, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = "scale(1)";
        e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
      }}
    >
      {actionLoading ? (
        <CircularProgress size={16} color="inherit" />
      ) : (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Calculator/Dashboard icon combined with refresh element */}
          <rect x="4" y="3" width="16" height="18" rx="2" />
          <line x1="8" y1="7" x2="16" y2="7" />
          <line x1="8" y1="12" x2="16" y2="12" />
          <line x1="8" y1="17" x2="12" y2="17" />
          <path d="M20 12c0-2.5-1-4.5-3-5.5" />
          <path d="M19 9.5v-2.5h-2.5" />
        </svg>
      )}
      Recalculate
    </button>
  );

  const countVehiclesByChassis = (chassisNumber) => {
    // Start with all vehicles, excluding transferred ones
    let filteredVehicles = vehiclesData.filter(
      (vehicle) => !vehicle.transferred
    );

    // Apply other active filters
    if (selectedProjects.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedProjects.includes(vehicle.projectName)
      );
    }

    if (selectedVehicleTypes.length > 0) {
      filteredVehicles = filteredVehicles.filter((vehicle) =>
        selectedVehicleTypes.includes(vehicle.vehicleType || vehicle.type)
      );
    }

    // Count vehicles matching this chassis number
    return filteredVehicles.filter(
      (vehicle) => vehicle.chassisNumber === chassisNumber
    ).length;
  };
  const handleOpenBreakdownModal = (breakdownHistory) => {
    setSelectedBreakdowns(breakdownHistory);
    setBreakdownModalOpen(true);
  };
  const getUniqueProjects = () => {
    return [...new Set(vehiclesData.map((item) => item.projectName))].filter(
      Boolean
    );
  };
  const renderServiceDescription = (description, additionalCount, item) => {
    if (description === "--") return highlightText("--", searchQuery);

    return (
      <div
        className="description-container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          {highlightText(description, searchQuery)}
          {additionalCount > 0 && (
            <span
              style={{
                color: "#333",
                fontSize: "12px",
                fontWeight: 500,
                marginLeft: "5px",
                backgroundColor: "#fdd34d",
                padding: "2px 5px",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              +{additionalCount}
            </span>
          )}
        </div>
        <>
          <IconButton
            size="small"
            onClick={() => {
              setSelectedItem(item.maintenanceSchedule);
              setMaintenanceModalOpen(true);
            }}
            sx={{ padding: "4px" }}
          >
            <ExpandMoreIcon fontSize="small" />
          </IconButton>
        </>
      </div>
    );
  };

  // Add this before the return statement
  const renderMaintenanceModal = () => {
    if (maintenanceModalOpen && selectedItem) {
      return (
        <MaintenanceModal
          maintenanceSchedule={selectedItem}
          onClose={() => {
            setMaintenanceModalOpen(false);
            setSelectedItem(null);
          }}
        />
      );
    }
    return null;
  };

  const getUniqueVehicleTypes = () => {
    return [
      ...new Set(vehiclesData.map((item) => item.vehicleType || item.type)),
    ].filter(Boolean);
  };

  // Modify the fetchVehicles function to include more granular progress updates
  const fetchVehicles = useCallback(async () => {
    setIsLoading(true);
    setLoadingProgress(0);

    // Force a render to happen by creating a small delay
    const forceRender = (progress) => {
      return new Promise((resolve) => {
        // Set the progress immediately
        setLoadingProgress(progress);

        // Wait to ensure the UI updates
        setTimeout(resolve, 300);
      });
    };

    try {
      // Initial loading (0-30%)
      await forceRender(0.05);
      await forceRender(0.1);
      await forceRender(0.15);
      await forceRender(0.2);
      await forceRender(0.25);
      await forceRender(0.3);

      // At this point you mentioned it jumps to showing entries
      // Let's add more explicit steps between 30-100%
      await forceRender(0.4);

      // Fetch the actual data
      const userSnapshot = await secondDatabase
        .ref(`userDetails/${firmId}`)
        .once("value");

      await forceRender(0.5);

      const userData = userSnapshot.val();
      if (!userData) {
        // Complete the loading normally even with no data
        await forceRender(0.6);
        await forceRender(0.7);
        await forceRender(0.8);
        await forceRender(0.9);
        await forceRender(1.0);
        setIsLoading(false);
        return;
      }

      await forceRender(0.6);

      const { firmDetailsID } = userData.personalDetails.firmDetails;
      const projects = Object.values(userData.projects || []);
      setProjects(projects);

      await forceRender(0.7);

      // Fetch firm data
      console.log("Fetching firm data...");
      console.log("Firm ID:", firmDetailsID);
      const firmSnapshot = await secondDatabase
        .ref(firmDetailsID)
        .once("value");

      await forceRender(0.8);

      const firmData = firmSnapshot.val();

      // Process vehicles
      const allVehicles = [];

      if (firmData && projects.length > 0) {
        projects.forEach(({ projectID, projectName }) => {
          const vehicles = firmData[projectID]?.vehicles;

          if (vehicles) {
            Object.entries(vehicles).forEach(([id, data]) => {
              allVehicles.push({
                ...data,
                id,
                projectId: projectID,
                projectName,
              });
            });
          }
        });
      }

      await forceRender(0.9);

      setVehiclesData(allVehicles);

      await forceRender(0.95);
      await forceRender(1.0);
    } catch (error) {
      console.error("Error fetching vehicles:", error);

      // Even on error, complete the loading animation
      await forceRender(0.7);
      await forceRender(0.8);
      await forceRender(0.9);
      await forceRender(1.0);

      setSnackbar({
        open: true,
        message: "Error fetching vehicles data",
        severity: "error",
      });
    } finally {
      // Final delay to ensure the loading completes before showing content
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [firmId]);

  // Add this useEffect to fetch vehicles when firmId changes
  useEffect(() => {
    if (firmId) {
      fetchVehicles();
    }
  }, [firmId]);

  // In your Vehicles.js component, modify the code to:
  useEffect(() => {
    const fetchData = async () => {
      try {
        const useRef = secondDatabase.ref(`userDetails/${firmId}`);

        useRef.on("value", function (snapshot) {
          var data = snapshot.val();
          if (data !== null) {
            setFirmDetailsId(data.personalDetails.firmDetails.firmDetailsID);
            setProjects(Object.values(data.projects));

            const firmUseRef = secondDatabase.ref(
              `${data.personalDetails.firmDetails.firmDetailsID}`
            );

            firmUseRef.on("value", function (snapshot) {
              var firmData = snapshot.val();
              if (firmData !== null) {
                setFirmData(firmData);

                let latestDate = new Date(0);
                Object.values(firmData || {}).forEach((project) => {
                  const vehicleMovements =
                    project?.vehicleMovementRecords || {};
                  Object.keys(vehicleMovements).forEach((timestamp) => {
                    const date = new Date(parseInt(timestamp));
                    if (date > latestDate) {
                      latestDate = date;
                    }
                  });
                });

                // If we found data, set the dates
                if (latestDate.getTime() !== 0) {
                  const sevenDaysBefore = new Date(latestDate);
                  sevenDaysBefore.setDate(latestDate.getDate() - 7);
                  setEndDate(latestDate);
                  setStartDate(sevenDaysBefore);
                }

                // Get vehicles data from all projects
                let allVehicles = [];
                Object.values(data.projects).forEach((project) => {
                  const projectData = firmData[project.projectID];
                  if (projectData && projectData.vehicles) {
                    allVehicles = [
                      ...allVehicles,
                      ...Object.values(projectData.vehicles),
                    ];
                  }
                });

                if (allVehicles.length > 0) {
                  setVehiclesData(allVehicles);
                  const processedMaintenanceData = allVehicles.map(
                    (vehicle) => {
                      const maintenanceSchedule =
                        vehicle.maintenanceSchedule || [];
                      const breakdownHistory = vehicle.breakdownHistory || {};

                      // Calculate breakdown stats
                      const breakdownStats = Object.values(
                        breakdownHistory
                      ).reduce(
                        (stats, breakdown) => ({
                          totalCost:
                            stats.totalCost + (breakdown.repairCost || 0),
                          count: stats.count + 1,
                          repairedCount:
                            stats.repairedCount +
                            (breakdown.alreadyRepaired ? 1 : 0),
                        }),
                        { totalCost: 0, count: 0, repairedCount: 0 }
                      );

                      // Process service history
                      let totalServiceCost = 0;
                      let allServiceHistories = [];

                      maintenanceSchedule.forEach((schedule) => {
                        const serviceHistory = schedule.serviceHistory || {};
                        Object.values(serviceHistory).forEach((service) => {
                          allServiceHistories.push({
                            date: service.date,
                            description: service.description,
                            amount: service.amount || 0,
                          });
                          totalServiceCost += service.amount || 0;
                        });
                      });

                      // Sort service histories by date (most recent first)
                      allServiceHistories.sort((a, b) => b.date - a.date);

                      const serviceDescription =
                        allServiceHistories.length > 0
                          ? allServiceHistories[0].description
                          : "--";
                      const additionalServicesCount =
                        allServiceHistories.length > 0
                          ? allServiceHistories.length - 1
                          : 0;

                      // Calculate next service details based on cycle type
                      const calculateNextService = () => {
                        const currentSchedule = maintenanceSchedule[0];
                        if (!currentSchedule)
                          return { nextService: "--", showAlert: false };

                        const cycle = parseFloat(currentSchedule.cycle) || 0;
                        const cycleType = currentSchedule.cycleType;
                        const lastServiceDate = allServiceHistories[0]?.date
                          ? new Date(allServiceHistories[0].date)
                          : new Date(maintenanceSchedule[0].lastService);

                        switch (cycleType) {
                          case "hours":
                            const totalHours =
                              parseFloat(vehicle.totalHoursWorked) || 0;
                            // Calculate remaining hours until next service based on cycle
                            const remainingHours = cycle - (totalHours % cycle);
                            // Alert if within 50 hours of next service
                            const showHoursAlert = remainingHours <= 50;

                            return {
                              nextService: `${Math.max(
                                0,
                                remainingHours
                              ).toFixed(2)} hrs`,
                              showAlert: showHoursAlert,
                              cycleType: "hrs",
                            };

                          case "km":
                            const totalKm =
                              parseFloat(vehicle.totalKilometers) || 0;
                            // Calculate remaining km until next service based on cycle
                            const remainingKm = cycle - (totalKm % cycle);
                            // Alert if within 500 km of next service
                            const showKmAlert = remainingKm <= 500;

                            return {
                              nextService: `${Math.max(0, remainingKm).toFixed(
                                2
                              )} km`,
                              showAlert: showKmAlert,
                              cycleType: "km",
                            };

                          case "days":
                            if (!lastServiceDate)
                              return {
                                nextService: "--",
                                showAlert: false,
                                cycleType: "days",
                              };

                            const today = new Date();
                            const daysSinceService = Math.floor(
                              (today - lastServiceDate) / (1000 * 60 * 60 * 24)
                            );
                            const remainingDays =
                              cycle - (daysSinceService % cycle);

                            // Alert if within 7 days of next service
                            const showDaysAlert = remainingDays <= 7;

                            return {
                              nextService: `${Math.max(0, remainingDays)} days`,
                              showAlert: showDaysAlert,
                              cycleType: "days",
                            };

                          default:
                            return {
                              nextService: "--",
                              showAlert: false,
                              cycleType: null,
                            };
                        }
                      };

                      const nextServiceDetails = calculateNextService(); // Validate hours and fuel consumed values
                      const validatedHours =
                        !isNaN(parseFloat(vehicle.totalHoursWorked)) &&
                        parseFloat(vehicle.totalHoursWorked) >= 0 &&
                        parseFloat(vehicle.totalHoursWorked) < 100000
                          ? parseFloat(vehicle.totalHoursWorked)
                          : 0;

                      const validatedFuelConsumed =
                        !isNaN(parseFloat(vehicle.totalDieselConsumed)) &&
                        parseFloat(vehicle.totalDieselConsumed) >= 0 &&
                        parseFloat(vehicle.totalDieselConsumed) < 1000000
                          ? parseFloat(vehicle.totalDieselConsumed)
                          : 0;

                      return {
                        projectName: vehicle.projectName,
                        chassisNumber: vehicle.chassisNumber,
                        type: vehicle.vehicleType,
                        number: vehicle.vehicleNumber,
                        hours: validatedHours,
                        fuelConsumed: validatedFuelConsumed,
                        efficiency: calculateEfficiency({
                          ...vehicle,
                          totalHoursWorked: validatedHours,
                          totalDieselConsumed: validatedFuelConsumed,
                        }),
                        maintenanceSchedule: maintenanceSchedule,
                        nextServiceIn: nextServiceDetails.nextService,
                        showServiceAlert: nextServiceDetails.showAlert,
                        serviceCycleType: nextServiceDetails.cycleType,
                        lastServiceDate: allServiceHistories[0]?.date
                          ? new Date(
                              allServiceHistories[0].date
                            ).toLocaleDateString()
                          : maintenanceSchedule[0]?.lastService
                          ? new Date(
                              maintenanceSchedule[0]?.lastService
                            ).toLocaleDateString()
                          : "--",
                        serviceDescription: serviceDescription,
                        additionalServicesCount: additionalServicesCount,
                        cycleType: maintenanceSchedule[0]?.cycleType || "--",
                        totalServiceCost: totalServiceCost,
                        engine2: vehicle.engine2 || null,
                        numberOfBreakdowns: {
                          total: breakdownStats.count,
                          repaired: breakdownStats.repairedCount,
                          pending:
                            breakdownStats.count - breakdownStats.repairedCount,
                        },
                        totalBreakdownCost: breakdownStats.totalCost,
                      };
                    }
                  );

                  setMaintenanceData(processedMaintenanceData);
                }
                setIsLoading(false);
              } else {
                setFirmData([]);
                setIsLoading(false);
              }
            });
          } else {
            setProjects([]);
            setIsLoading(false);
          }
        });
      } catch (error) {
        console.log("error", error);
      }
    };
    if (firmId) {
      fetchData();
    }
  }, [firmId]);

  // Utility function to highlight searched text
  const highlightText = (text, searchQuery) => {
    if (!searchQuery) return text;
    const parts = String(text).split(new RegExp(`(${searchQuery})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === searchQuery.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "#fdd34d" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // Filter function for search
  const filterData = (data) => {
    let filteredData = data;

    // Apply project filter
    if (selectedProjects.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedProjects.includes(item.projectName)
      );
    }

    // Apply vehicle type filter
    if (selectedVehicleTypes.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedVehicleTypes.includes(item.vehicleType || item.type)
      );
    }

    // Apply chassis number filter
    if (selectedChassisNumbers.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedChassisNumbers.includes(item.chassisNumber)
      );
    }

    // Apply search query
    if (searchQuery) {
      filteredData = filteredData.filter((item) => {
        const searchInObject = (obj) => {
          return Object.entries(obj).some(([key, value]) => {
            if (value === null || value === undefined) return false;
            if (typeof value === "object") return searchInObject(value);
            return String(value)
              .toLowerCase()
              .includes(searchQuery.toLowerCase());
          });
        };
        return searchInObject(item);
      });
    }

    return filteredData;
  };

  // setConsumptionHistoryData(dailyData);
  useEffect(() => {
    if (firmData && firmData.projects) {
      const dailyData = [];

      Object.keys(firmData.projects).forEach((projectId) => {
        const projectData = projects.find((p) => p.projectID === projectId);
        const projectName = projectData ? projectData.projectName : "--";

        const outwardsData =
          firmData.projects[projectId]?.records?.allOutward || {};

        Object.values(outwardsData).forEach((outward) => {
          if (outward?.outwardItems) {
            Object.values(outward.outwardItems).forEach((item) => {
              if (item.type === "vehicle" && item.consumption) {
                Object.entries(item.consumption).forEach(
                  ([timestamp, value]) => {
                    const date = new Date(parseInt(timestamp));

                    if (date >= startDate && date <= endDate) {
                      const hours = parseFloat(value.hours) || 0;
                      const meetsTimeFilter =
                        timeFilter === "all"
                          ? true
                          : timeFilter === "< 8 hours"
                          ? hours < 8
                          : false;

                      if (meetsTimeFilter) {
                        const dieselConsumed = parseFloat(value.quantity) || 0;
                        const matchingVehicle = vehiclesData.find(
                          (v) => v.tag === value.tag
                        );
                        dailyData.push({
                          tag: value.tag,
                          projectName: projectName,
                          type: matchingVehicle?.vehicleType || "--",
                          number: matchingVehicle?.vehicleNumber || "--",
                          chassisNumber: matchingVehicle?.chassisNumber || "--",
                          readingType: matchingVehicle?.readingType || "hrs",
                          hours: value.hours || "--",
                          engine2Hours: value.engine2Hours || "--",
                          fuelConsumed: dieselConsumed.toFixed(2),
                          efficiency:
                            hours > 0
                              ? (dieselConsumed / hours).toFixed(2)
                              : "--",
                          purpose: value.purpose || "--",
                          date: date,
                          startReading: value.startReading || "--",
                          endReading: value.endReading || "--",
                          engine2StartReading:
                            value.engine2StartReading || "--",
                          engine2EndReading: value.engine2EndReading || "--",
                          kmsStartReading: value.kmsStartReading || "--",
                          kmsEndReading: value.kmsEndReading || "--",
                          kmsTravelled: value.kmsTravelled || "--",
                          amount: value.amount || "--",
                          totalAmount: value.amount
                            ? (dieselConsumed * value.amount).toFixed(2)
                            : "--",
                        });
                      }
                    }
                  }
                );
              }
            });
          }
        });
      });

      dailyData.sort((a, b) => b.date - a.date);
      setConsumptionHistoryData(dailyData);
    }
  }, [firmData, projects, vehiclesData, startDate, endDate, timeFilter]);

  const renderDailyReportTable = () => {
    const dailyData = [];

    if (firmData) {
      Object.keys(firmData).forEach((projectId) => {
        const projectData = projects.find((p) => p.projectID === projectId);
        const projectName = projectData ? projectData.projectName : "--";

        // Change to use vehicleMovementRecords
        const vehicleMovements =
          firmData[projectId]?.vehicleMovementRecords || {};

        Object.entries(vehicleMovements).forEach(([timestamp, movement]) => {
          const date = new Date(parseInt(timestamp));

          if (date >= startDate && date <= endDate) {
            const hours = parseFloat(movement.hours) || 0;
            const meetsTimeFilter =
              timeFilter === "all"
                ? true
                : timeFilter === "< 8 hours"
                ? hours < 8
                : false;

            if (meetsTimeFilter) {
              const dieselConsumed = parseFloat(movement.quantity) || 0;
              const matchingVehicle = vehiclesData.find(
                (v) => v.tag === movement.tag
              );
              dailyData.push({
                projectName: projectName,
                by: movement.by || "--",
                date: date,
                type: matchingVehicle?.vehicleType || "--",
                number: matchingVehicle?.vehicleNumber || "--",
                chassisNumber: matchingVehicle?.chassisNumber || "--",
                startReading: movement.startReading || "--",
                endReading: movement.endReading || "--",
                hours: movement.hours || "--",
                engine2StartReading: movement.engine2StartReading || "--",
                engine2EndReading: movement.engine2EndReading || "--",
                engine2Hours: movement.engine2Hours || "--",
                kmsStartReading: movement.kmsStartReading || "--",
                kmsEndReading: movement.kmsEndReading || "--",
                kmsTravelled: movement.kmsTravelled || "--",
                fuelConsumed: dieselConsumed.toFixed(2),
                amount: movement.amount || "--",
                totalAmount: movement.amount
                  ? (dieselConsumed * movement.amount).toFixed(2)
                  : "--",
                purpose: movement.purpose || "--",
                quantity: movement.quantity || "--",
              });
            }
          }
        });
      });
    }

    dailyData.sort((a, b) => b.date - a.date);

    return (
      <div className="table-wrapper">
        <div className="table-scroll-container">
          <table>
            <thead>
              <tr>
                <th>Project name</th>
                <th>By</th>

                <th>Date</th>
                <th>Type</th>
                <th>Number</th>
                <th>Chassis number</th>
                <th>Start Reading</th>
                <th>End Reading</th>
                <th>Engine 1 Hours</th>
                <th>Engine 2 Start Reading</th>
                <th>Engine 2 End Reading</th>
                <th>Engine 2 Hours</th>
                <th>Opening Kms</th>
                <th>Closing Kms</th>
                <th>Kms Travelled</th>
                <th>Fuel consumed</th>
                <th>Amount(Per L)</th>
                <th>Total Amount</th>
                <th style={{ minWidth: "400px", width: "400px" }}>Purpose</th>
              </tr>
            </thead>
            <tbody>
              {filterData(dailyData).map((item, index) => (
                <tr key={index}>
                  <td>{highlightText(item.projectName, searchQuery)}</td>
                  <td>{highlightText(item.by, searchQuery)}</td>
                  <td>
                    {highlightText(item.date.toLocaleDateString(), searchQuery)}
                  </td>
                  <td>{highlightText(item.type, searchQuery)}</td>
                  <td>{highlightText(item.number, searchQuery)}</td>
                  <td>{highlightText(item.chassisNumber, searchQuery)}</td>
                  <td>{highlightText(item.startReading, searchQuery)}</td>
                  <td>{highlightText(item.endReading, searchQuery)}</td>
                  <td>{highlightText(item.hours, searchQuery)}</td>
                  <td>
                    {highlightText(item.engine2StartReading, searchQuery)}
                  </td>
                  <td>{highlightText(item.engine2EndReading, searchQuery)}</td>
                  <td>{highlightText(item.engine2Hours, searchQuery)}</td>
                  <td>{highlightText(item.kmsStartReading, searchQuery)}</td>
                  <td>{highlightText(item.kmsEndReading, searchQuery)}</td>
                  <td>{highlightText(item.kmsTravelled, searchQuery)}</td>
                  <td>{highlightText(item.quantity, searchQuery)}</td>
                  <td className="tdClass">
                    {highlightText(item.amount, searchQuery)}
                  </td>
                  <td className="tdClass">
                    {highlightText(item.totalAmount, searchQuery)}
                  </td>
                  <td className="tdClass">
                    {highlightText(item.purpose, searchQuery)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  const calculateEfficiency = (vehicle) => {
    // Handle case where vehicle is undefined or null
    if (!vehicle) return "--";

    // Extract values and track potential issues
    const totalDieselConsumed = parseFloat(vehicle.totalDieselConsumed);
    const totalHoursWorked = parseFloat(vehicle.totalHoursWorked);

    // If no hours worked or zero consumption, return placeholder
    if (
      isNaN(totalDieselConsumed) ||
      isNaN(totalHoursWorked) ||
      totalHoursWorked <= 0
    ) {
      return "--";
    }

    // Additional validation to prevent unreasonable values
    if (
      totalDieselConsumed < 0 ||
      totalDieselConsumed > 1000000 || // Unrealistically high fuel consumption
      totalHoursWorked < 0 ||
      totalHoursWorked > 100000 // Unrealistically high hours
    ) {
      return "--";
    }

    // Calculate basic efficiency
    const efficiency = totalDieselConsumed / totalHoursWorked;

    // Check for valid result and reasonable values (typically between 0.1 and 100 L/hr)
    if (isNaN(efficiency) || efficiency < 0 || efficiency > 100) {
      return "--";
    }

    // Round to 2 decimal places for display
    return efficiency.toFixed(2);
  };
  const calculateDateFilteredMetrics = (vehicle, startDate, endDate) => {
    // Default values if no data is found
    const defaultMetrics = {
      totalHoursWorked: 0,
      totalDieselConsumed: 0,
      totalKilometers: 0,
      amount: 0,
      engine2: {
        totalHoursWorked: 0,
      },
    };

    // If no vehicle data or no firm data, return defaults
    if (!vehicle || !firmData) {
      return defaultMetrics;
    }

    // Find all vehicle movements for this vehicle within the date range
    const filteredMovements = [];

    // Loop through all projects to find relevant vehicle movements
    Object.keys(firmData).forEach((projectId) => {
      const vehicleMovements =
        firmData[projectId]?.vehicleMovementRecords || {};

      Object.entries(vehicleMovements).forEach(([timestamp, movement]) => {
        const date = new Date(parseInt(timestamp));

        // Only include records within the selected date range and matching this vehicle's tag
        if (
          date >= startDate &&
          date <= endDate &&
          movement.tag === vehicle.tag
        ) {
          filteredMovements.push(movement);
        }
      });
    });

    // Calculate totals from the filtered movements
    return filteredMovements.reduce((totals, movement) => {
      // Calculate hours directly from the movement record
      // For readings, we prefer to use the already calculated 'hours' field if available
      // If not, we calculate it from endReading - startReading
      let hours = 0;
      if (movement.hours && movement.hours !== "") {
        hours = parseFloat(movement.hours) || 0;
      } else if (movement.endReading && movement.startReading) {
        hours =
          parseFloat(movement.endReading) - parseFloat(movement.startReading);
      }

      // Similarly for engine2 hours
      let engine2Hours = 0;
      if (movement.engine2Hours && movement.engine2Hours !== "") {
        engine2Hours = parseFloat(movement.engine2Hours) || 0;
      } else if (movement.engine2EndReading && movement.engine2StartReading) {
        engine2Hours =
          parseFloat(movement.engine2EndReading) -
          parseFloat(movement.engine2StartReading);
      }

      // For kilometers traveled
      let kmsTravelled = 0;
      if (movement.kmsTravelled && movement.kmsTravelled !== "") {
        kmsTravelled = parseFloat(movement.kmsTravelled) || 0;
      } else if (movement.kmsEndReading && movement.kmsStartReading) {
        kmsTravelled =
          parseFloat(movement.kmsEndReading) -
          parseFloat(movement.kmsStartReading);
      }

      // Fuel consumed and amount
      const dieselConsumed = parseFloat(movement.quantity) || 0;
      const rate = parseFloat(movement.amount) || 0;
      const movementAmount = dieselConsumed * rate;

      return {
        totalHoursWorked: totals.totalHoursWorked + hours,
        totalDieselConsumed: totals.totalDieselConsumed + dieselConsumed,
        totalKilometers: totals.totalKilometers + kmsTravelled,
        amount: totals.amount + movementAmount,
        engine2: {
          totalHoursWorked: totals.engine2.totalHoursWorked + engine2Hours,
        },
      };
    }, defaultMetrics);
  };
  const getExpectedMileage = (model) => {
    // Map vehicle models to their expected mileage from PDF
    const mileageMap = {
      "JCB 130": "6-7", // EXCAVATOR
      "JCB 3DX": "4-5", // BUCKET LOADER
      "JCB VM117": "7-8", // SOIL COMPACTOR
      "JCB VMT330": "4", // MINI SOIL COMPACTOR
      SLM4600: "7-8", // CONCRETE MIXER SCHWING STETTER
      "DBX 5000": "--", // CONCRETE MIXER FIORI (no data in PDF)
      "ARGO 4800": "8-10", // CONCRETE MIXER AJAX
      "MA1920/36 T": "3", // TIPPER ASHOK LEYLAND
      "5042D": "4-5", // TRACTOR JOHN DEERE
      "5042D V3": "4-5", // TRACTOR JOHN DEERE variant
      "5310 V1 GEARPRO": "5-6", // TRACTOR JOHN DEERE
      "5310E": "5-6", // TRACTOR JOHN DEERE variant
      "5310 V1": "5-6", // TRACTOR JOHN DEERE variant
      "5310 V16": "5-6", // TRACTOR JOHN DEERE variant
      "14XW": "3.25", // HYDRA CRANE ACE
    };

    // For handling model variants
    const baseModel = Object.keys(mileageMap).find((key) =>
      model?.toUpperCase().includes(key)
    );

    return baseModel ? mileageMap[baseModel] : "--";
  };

  const calculateEfficiencyRatio = (actual, expected) => {
    if (actual === "--" || expected === "--") return "--";

    // For ranges like '6-7', use the average
    const getNumericValue = (value) => {
      if (value.includes("-")) {
        const [min, max] = value.split("-").map(Number);
        return (min + max) / 2;
      }
      return Number(value);
    };

    const actualValue = getNumericValue(actual);
    const expectedValue = getNumericValue(expected);

    if (isNaN(actualValue) || isNaN(expectedValue) || expectedValue === 0)
      return "--";

    const ratio = actualValue / expectedValue;
    return ratio.toFixed(2);
  };

  const renderVehicleInformationTable = () => {
    // Check if date filtering is active (both start and end dates are set)
    const isDateFilterActive = startDate && endDate;

    // Helper function to validate fuel consumption rate
    const validateFuelRate = (rate) => {
      // Check if it's not a valid number or is unreasonably large (>100 L/hr)
      if (rate === "--" || isNaN(rate) || rate <= 0 || rate > 100) {
        return "--";
      }
      return rate;
    };

    // Helper function to validate hours
    const validateHours = (hours) => {
      // Check if it's not a valid number, negative, or unreasonably large (>100,000 hours)
      if (isNaN(hours) || hours < 0 || hours > 100000) {
        return "--";
      }
      return hours.toFixed(2);
    };

    return (
      <div className="table-wrapper">
        {/* Show a notification banner when date filtering is active */}

        <div className="table-scroll-container">
          <table>
            <thead>
              <tr>
                <th colSpan="1" className="group-header">
                  Actions
                </th>
                <th colSpan="6" className="group-header">
                  VEHICLE DETAILS
                </th>
                <th colSpan="2" className="group-header">
                  FUEL
                </th>
                <th colSpan="3" className="group-header">
                  ENGINE HOURS
                </th>
                <th colSpan="2" className="group-header">
                  KILOMETERS
                </th>
                <th colSpan="5" className="group-header">
                  PERFORMANCE METRICS
                </th>
                <th colSpan="3" className="group-header">
                  CUMULATIVE MOVEMENT
                </th>
                <th colSpan="2" className="group-header">
                  PURCHASE
                </th>
                <th colSpan="3" className="group-header">
                  INSURANCE
                </th>
                <th colSpan="6" className="group-header">
                  PERMIT & FITNESS
                </th>
              </tr>
              <tr>
                <th></th>
                <th>Project Name</th>
                <th>Chassis Number</th>
                <th>Vehicle Number</th>
                <th>Type</th>
                <th>Make</th>
                <th>Model</th>
                <th>Total Fuel (L)</th>
                <th>Total Amount (₹)</th>
                <th>Engine 1 Hours</th>
                <th>Engine 2 Hours</th>
                <th>Total Hours</th>
                <th>Total Kms</th>
                <th>Avg (km/L)</th>
                <th>Avg Fuel (L/hr)</th>
                <th>Expected Fuel (L/hr)</th>
                <th>Efficiency Ratio</th>
                <th>Above 8hrs</th>
                <th>Below 8hrs</th>
                <th>Hours Worked</th>
                <th>Avg Fuel (L/hr)</th>
                <th>No Movement</th>
                <th>Month</th>
                <th>Year</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Provider</th>
                <th>Permit Number</th>
                <th>Permit Range</th>
                <th>Valid Until</th>
                <th>FC Number</th>
                <th>FC Valid Until</th>
                <th>Road Tax Valid Until</th>
              </tr>
            </thead>
            <tbody>
              {filterData(vehiclesData).map((item, index) => {
                // Calculate date-filtered metrics if date filtering is active
                let metrics = item;

                if (isDateFilterActive) {
                  // Use our dedicated function to calculate filtered metrics
                  metrics = calculateDateFilteredMetrics(
                    item,
                    startDate,
                    endDate
                  );
                }

                // Calculate total hours (engine1 + engine2) with validation
                const engine1Hours = parseFloat(metrics.totalHoursWorked) || 0;
                const engine2Hours =
                  parseFloat(metrics.engine2?.totalHoursWorked) || 0;
                const totalHours = engine1Hours + engine2Hours;

                // Validate total hours
                const validatedTotalHours =
                  isNaN(totalHours) || totalHours < 0 || totalHours > 100000
                    ? "--"
                    : totalHours.toFixed(2);

                // Calculate the mileage (L/hr) based on appropriate metrics
                let avgFuelPerHour = "--";
                const totalDieselConsumed =
                  parseFloat(metrics.totalDieselConsumed) || 0;
                if (totalHours > 0 && totalDieselConsumed > 0) {
                  // Calculate and validate to prevent unrealistic values
                  const calculatedRate = totalDieselConsumed / totalHours;
                  avgFuelPerHour =
                    calculatedRate > 0 && calculatedRate <= 100
                      ? calculatedRate.toFixed(2)
                      : "--";
                }

                // Calculate km/L
                const totalKms =
                  parseFloat(metrics.totalKilometers || metrics.kmsTravelled) ||
                  0;
                let kmPerLiter = "--";
                if (totalDieselConsumed > 0 && totalKms > 0) {
                  // Calculate and validate to prevent unrealistic values
                  const calculatedKmPerLiter = totalKms / totalDieselConsumed;
                  kmPerLiter =
                    calculatedKmPerLiter > 0 && calculatedKmPerLiter <= 100
                      ? calculatedKmPerLiter.toFixed(2)
                      : "--";
                }

                // Get the expected mileage for this vehicle model
                const expectedMileage = getExpectedMileage(item.model);

                // Calculate efficiency ratio
                const efficiencyRatio = calculateEfficiencyRatio(
                  avgFuelPerHour,
                  expectedMileage
                );

                // Calculate movement statistics for this vehicle based on date filters
                let above8Hours = 0;
                let below8Hours = 0;
                let noMovement = 0;

                if (firmData) {
                  // Loop through all projects to find relevant vehicle movements
                  Object.keys(firmData).forEach((projectId) => {
                    const vehicleMovements =
                      firmData[projectId]?.vehicleMovementRecords || {};

                    Object.entries(vehicleMovements).forEach(
                      ([timestamp, movement]) => {
                        const date = new Date(parseInt(timestamp));

                        // Check if movement record is within date range and matches this vehicle
                        if (
                          (!isDateFilterActive ||
                            (date >= startDate && date <= endDate)) &&
                          movement.tag === item.tag
                        ) {
                          const hours = parseFloat(movement.hours) || 0;

                          if (hours >= 8) {
                            above8Hours++;
                          } else if (hours > 0) {
                            below8Hours++;
                          } else {
                            noMovement++;
                          }
                        }
                      }
                    );
                  });
                } // Calculate CUMULATIVE values - these should NOT be affected by date filters
                // These represent the total lifetime metrics for the vehicle
                // Store the original data for access to unfiltered values
                const originalData = item.originalData || item;

                // Add validation to prevent unreasonable values
                const engine1HoursTotal =
                  parseFloat(originalData.totalHoursWorked) || 0;
                const engine2HoursTotal =
                  parseFloat(originalData.engine2?.totalHoursWorked) || 0;
                const cumulativeTotalHours =
                  engine1HoursTotal + engine2HoursTotal;

                // Validate cumulative hours to prevent unrealistic values
                let validatedCumulativeHours = "--";
                if (!isNaN(cumulativeTotalHours) && cumulativeTotalHours >= 0) {
                  validatedCumulativeHours = cumulativeTotalHours.toFixed(2);
                } // Calculate cumulative average fuel per hour with validation
                let cumulativeAvgFuelPerHour = "--";
                // Access total diesel consumed from original unfiltered data
                const cumulativeTotalDieselConsumed =
                  parseFloat(originalData.totalDieselConsumed) || 0;
                if (
                  cumulativeTotalHours > 0 &&
                  cumulativeTotalDieselConsumed > 0
                ) {
                  // Calculate and validate to prevent unrealistic values
                  const calculatedRate =
                    cumulativeTotalDieselConsumed / cumulativeTotalHours;
                  cumulativeAvgFuelPerHour =
                    calculatedRate > 0 && calculatedRate <= 100
                      ? calculatedRate.toFixed(2)
                      : "--";
                }

                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: item.transferred
                        ? "#FFCCEA"
                        : index % 2 === 0
                        ? "#fafafa"
                        : "white",
                    }}
                  >
                    {/* Actions cell */}
                    <td>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip
                          title={
                            item.transferred
                              ? "Transferred vehicles cannot be edited"
                              : "Edit vehicle"
                          }
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedVehicle(item);
                                setIsEditModalOpen(true);
                              }}
                              disabled={item.transferred}
                              sx={{
                                color: item.transferred
                                  ? "grey.400"
                                  : "primary.main",
                                "&:hover": {
                                  backgroundColor: item.transferred
                                    ? "transparent"
                                    : "rgba(0, 123, 255, 0.04)",
                                },
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>

                        <Tooltip
                          title={
                            item.transferred
                              ? "Vehicle already transferred"
                              : item.sos
                              ? "Vehicle under maintenance cannot be transferred"
                              : "Transfer vehicle"
                          }
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedVehicle(item);
                                setIsTransferModalOpen(true);
                              }}
                              disabled={item.transferred || item.sos}
                              sx={{
                                color:
                                  item.transferred || item.sos
                                    ? "grey.400"
                                    : "primary.main",
                                "&:hover": {
                                  backgroundColor:
                                    item.transferred || item.sos
                                      ? "transparent"
                                      : "rgba(0, 123, 255, 0.04)",
                                },
                              }}
                            >
                              <CompareArrowsIcon fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>

                        {item.sos && (
                          <Tooltip title="Vehicle under maintenance">
                            <WarningIcon
                              fontSize="small"
                              sx={{ color: "warning.main" }}
                            />
                          </Tooltip>
                        )}

                        {item.transferred && (
                          <Tooltip title="Vehicle transferred">
                            <InfoIcon
                              fontSize="small"
                              sx={{ color: "info.main" }}
                            />
                          </Tooltip>
                        )}
                      </div>
                    </td>

                    {/* VEHICLE DETAILS section */}
                    <td>
                      {highlightText(item?.projectName || "--", searchQuery)}
                    </td>
                    <td>
                      {highlightText(item?.chassisNumber || "--", searchQuery)}
                    </td>
                    <td>
                      {highlightText(item?.vehicleNumber || "--", searchQuery)}
                    </td>
                    <td>
                      {highlightText(item?.vehicleType || "--", searchQuery)}
                    </td>
                    <td>{highlightText(item?.make || "--", searchQuery)}</td>
                    <td>{highlightText(item?.model || "--", searchQuery)}</td>

                    {/* FUEL section */}
                    <td>
                      {highlightText(
                        isDateFilterActive
                          ? (metrics.totalDieselConsumed || 0).toFixed(2)
                          : (item?.totalDieselConsumed || 0).toFixed(2),
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        isDateFilterActive
                          ? (metrics.amount || 0).toFixed(2)
                          : (item?.amount || 0).toFixed(2),
                        searchQuery
                      )}
                    </td>

                    {/* ENGINE HOURS section */}
                    <td>
                      {highlightText(
                        isDateFilterActive
                          ? (metrics.totalHoursWorked || 0).toFixed(2)
                          : (item?.totalHoursWorked || 0).toFixed(2),
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        isDateFilterActive
                          ? (metrics.engine2?.totalHoursWorked || 0).toFixed(2)
                          : (item?.engine2?.totalHoursWorked || 0).toFixed(2),
                        searchQuery
                      )}
                    </td>
                    <td>{highlightText(validatedTotalHours, searchQuery)}</td>

                    {/* KILOMETERS section */}
                    <td>
                      {highlightText(
                        isDateFilterActive
                          ? (metrics.totalKilometers || 0).toFixed(2)
                          : (
                              item?.totalKilometers ||
                              item?.kmsTravelled ||
                              0
                            ).toFixed(2),
                        searchQuery
                      )}
                    </td>
                    <td>{highlightText(kmPerLiter, searchQuery)}</td>

                    {/* PERFORMANCE METRICS section */}
                    <td>{highlightText(avgFuelPerHour, searchQuery)}</td>
                    <td>{highlightText(expectedMileage, searchQuery)}</td>
                    <td>{highlightText(efficiencyRatio, searchQuery)}</td>
                    <td>
                      {highlightText(
                        above8Hours > 0 ? above8Hours : "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        below8Hours > 0 ? below8Hours : "--",
                        searchQuery
                      )}
                    </td>

                    {/* CUMULATIVE MOVEMENT section - CONSTANT VALUES not affected by date filters */}
                    <td>
                      {highlightText(validatedCumulativeHours, searchQuery)}
                    </td>
                    <td>
                      {highlightText(cumulativeAvgFuelPerHour, searchQuery)}
                    </td>
                    <td>
                      {highlightText(
                        noMovement > 0 ? noMovement : "--",
                        searchQuery
                      )}
                    </td>

                    {/* PURCHASE section */}
                    <td>
                      {highlightText(
                        item?.monthOfPurchase || "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(item?.yearOfPurchase || "--", searchQuery)}
                    </td>

                    {/* INSURANCE section */}
                    <td>
                      {highlightText(
                        item?.insuranceStartDate
                          ? new Date(
                              item.insuranceStartDate
                            ).toLocaleDateString()
                          : "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        item?.insuranceEndDate
                          ? new Date(item.insuranceEndDate).toLocaleDateString()
                          : "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        item?.insuranceProvider || "--",
                        searchQuery
                      )}
                    </td>

                    {/* PERMIT & FITNESS section */}
                    <td>
                      {highlightText(item?.permitNo || "--", searchQuery)}
                    </td>
                    <td>
                      {highlightText(item?.permitRange || "--", searchQuery)}
                    </td>
                    <td>
                      {highlightText(
                        item?.permitValidUpto
                          ? new Date(item.permitValidUpto).toLocaleDateString()
                          : "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        item?.fitnessCertificateNo || "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        item?.fcValidUpto
                          ? new Date(item.fcValidUpto).toLocaleDateString()
                          : "--",
                        searchQuery
                      )}
                    </td>
                    <td>
                      {highlightText(
                        item?.roadTaxValidUpto
                          ? new Date(item.roadTaxValidUpto).toLocaleDateString()
                          : "--",
                        searchQuery
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderServiceScheduleTable = () => (
    <div className="table-wrapper">
      <div className="table-scroll-container">
        <table>
          <thead>
            <tr>
              <th colSpan="6" className="group-header">
                Vehicle
              </th>
              <th colSpan="2" className="group-header">
                Service Details
              </th>
              <th colSpan="3" className="group-header">
                Service History
              </th>
              <th colSpan="2" className="group-header">
                Breakdown
              </th>
              <th colSpan="1" className="group-header">
                Total Cost
              </th>
            </tr>
            <tr>
              <th>Project name</th>
              <th>Chassis number</th>
              <th>Type</th>
              <th>Number</th>
              <th>Hours</th>
              <th>Fuel consumed</th>
              <th>Next service in</th>
              <th>Last service Date</th>
              <th>Description</th>
              <th>Maintenance cost</th>
              <th>Cycle Type</th>
              <th>No of breakdowns</th>
              <th>Cost</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {filterData(maintenanceData).map((item, index) => (
              <tr key={index}>
                <td>{highlightText(item.projectName || "--", searchQuery)}</td>
                <td>
                  {highlightText(item.chassisNumber || "--", searchQuery)}
                </td>
                <td>{highlightText(item.type || "--", searchQuery)}</td>
                <td>{highlightText(item.number || "--", searchQuery)}</td>{" "}
                <td>
                  {highlightText(
                    item.hours &&
                      !isNaN(item.hours) &&
                      parseFloat(item.hours) >= 0
                      ? parseFloat(item.hours).toFixed(2)
                      : "--",
                    searchQuery
                  )}
                </td>
                <td>
                  {highlightText(
                    item.fuelConsumed &&
                      !isNaN(item.fuelConsumed) &&
                      parseFloat(item.fuelConsumed) >= 0
                      ? parseFloat(item.fuelConsumed).toFixed(2)
                      : "--",
                    searchQuery
                  )}
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between ",
                    }}
                  >
                    {highlightText(item.nextServiceIn || "--", searchQuery)}
                    {item.showServiceAlert && (
                      <WarningIcon
                        sx={{
                          color: "red",
                          fontSize: "20px",
                          marginLeft: "4px",
                        }}
                        titleAccess={item.nextServiceIn} // This will show "X hrs" or "X km" or "X days"
                      />
                    )}
                  </div>
                </td>
                <td>
                  {highlightText(item.lastServiceDate || "--", searchQuery)}
                </td>
                <td>
                  {renderServiceDescription(
                    item.serviceDescription,
                    item.additionalServicesCount,
                    item
                  )}
                </td>
                <td>
                  {highlightText(
                    item.totalServiceCost ? `₹${item.totalServiceCost}` : "--",
                    searchQuery
                  )}
                </td>
                <td>{highlightText(item.cycleType || "--", searchQuery)}</td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {highlightText(
                      `${item.numberOfBreakdowns.total}`,
                      searchQuery
                    )}
                    {item.numberOfBreakdowns.total > 0 && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          const vehicle = vehiclesData.find(
                            (v) => v.chassisNumber === item.chassisNumber
                          );
                          handleOpenBreakdownModal(vehicle.breakdownHistory);
                        }}
                        sx={{ padding: "4px" }}
                      >
                        <ExpandMoreIcon fontSize="small" />
                      </IconButton>
                    )}
                  </div>
                </td>
                <td>
                  {highlightText(
                    item.totalBreakdownCost
                      ? `₹${item.totalBreakdownCost}`
                      : "--",
                    searchQuery
                  )}
                </td>
                <td>
                  {highlightText(
                    Number(item.totalServiceCost) +
                      Number(item.totalBreakdownCost) >
                      0
                      ? `₹${
                          Number(item.totalServiceCost) +
                          Number(item.totalBreakdownCost)
                        }`
                      : "--",
                    searchQuery
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const tabStyle = (tabName) => ({
    padding: "10px 20px",
    borderRadius: "20px",
    color: activeTab === tabName ? "black" : "#666",
    backgroundColor: activeTab === tabName ? "#fdd34d" : "#f5f5f5",
    transition: "all 0.3s",
    cursor: "pointer",
    fontWeight: 500,
    fontSize: "14px",
  });
  const handleFuelInformationClick = () => {
    // If showing all projects (no filter) or no projects selected
    if (selectedProjects.length === 0) {
      history.push({
        pathname: "/Inventory",
        state: {
          comingFromVehicles: true,
          projectId: "All Sites", // Passing "All Sites" when no specific project is selected
        },
      });
      return;
    }

    // If multiple projects are selected, show an alert
    if (selectedProjects.length > 1) {
      alert("Please select only one project to view fuel information");
      return;
    }

    // If single project is selected, find its ID
    const selectedProject = projects.find(
      (p) => p.projectName === selectedProjects[0]
    );
    if (selectedProject) {
      history.push({
        pathname: "/Inventory",
        state: {
          comingFromVehicles: true,
          projectId: selectedProject.projectID,
        },
      });
    }
  };

  // Add these state variables in the component (near other state declarations)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <div className="vehicles-container">
      {isLoading ? (
        <LoadingComponent progressState={loadingProgress} />
      ) : (
        <>
          <div className="header-tabs-container">
            <div className="header-tabs">
              <div
                onClick={() => setActiveTab("daily")}
                style={tabStyle("daily")}
              >
                Daily Vehicle Report
              </div>
              <div
                onClick={() => setActiveTab("vehicle")}
                style={tabStyle("vehicle")}
              >
                Vehicle Information
              </div>
              <div
                onClick={() => setActiveTab("service")}
                style={tabStyle("service")}
              >
                Service schedule
              </div>
              <div
                onClick={handleFuelInformationClick}
                style={tabStyle("fuel")}
              >
                Fuel Information
              </div>
            </div>

            <div className="header-actions">
              <div className="controls-row">
                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  {/* Only show filters when in daily or vehicle tabs */}
                  {(activeTab === "daily" || activeTab === "vehicle") && (
                    <div className="filters">
                      {/* Only show time filter dropdown for daily tab */}
                      {activeTab === "daily" && (
                        <select
                          value={timeFilter}
                          onChange={(e) => setTimeFilter(e.target.value)}
                          className="time-filter"
                        >
                          <option value="all">Show All</option>
                          <option value="< 8 hours">Show {"<"} 8 hours</option>
                        </select>
                      )}

                      {/* Date pickers are now available for both daily and vehicle tabs */}
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <div className="date-pickers">
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            className="modern-date-picker"
                            slotProps={{
                              textField: {
                                size: "small",
                                placeholder: "Start Date",
                              },
                            }}
                          />
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#666",
                            }}
                          >
                            to
                          </span>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            className="modern-date-picker"
                            slotProps={{
                              textField: {
                                size: "small",
                                placeholder: "End Date",
                              },
                            }}
                          />
                        </div>
                      </LocalizationProvider>
                    </div>
                  )}

                  {/* Filters container with dropdown button */}
                  <div className="filters-container">
                    <button
                      className={`filter-trigger`}
                      onClick={() => setIsFilterOpen(!isFilterOpen)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
                      </svg>
                      Filters{" "}
                      {(selectedProjects.length > 0 ||
                        selectedVehicleTypes.length > 0 ||
                        selectedChassisNumbers.length > 0) &&
                        `(${
                          selectedProjects.length +
                          selectedVehicleTypes.length +
                          selectedChassisNumbers.length
                        })`}
                    </button>

                    {/* Filter dropdown modal */}
                    {isFilterOpen && (
                      <div className="filter-modal" ref={filterModalRef}>
                        <div className="filter-header">
                          <h3>Filters</h3>
                          <button
                            onClick={() => {
                              setSelectedProjects([]);
                              setSelectedVehicleTypes([]);
                              setSelectedChassisNumbers([]);
                            }}
                          >
                            Clear all
                          </button>
                        </div>

                        <div className="filter-content">
                          {/* Project filter section */}
                          <div className="filter-section">
                            <div className="filter-section-header">
                              <span className="filter-section-title">
                                Project Name
                              </span>
                              <button
                                className="select-all-btn"
                                onClick={() => {
                                  const allProjects = getUniqueProjects();
                                  setSelectedProjects(
                                    selectedProjects.length ===
                                      allProjects.length
                                      ? []
                                      : allProjects
                                  );
                                }}
                              >
                                {selectedProjects.length ===
                                getUniqueProjects().length
                                  ? "Unselect All"
                                  : "Select All"}
                              </button>
                            </div>

                            <div className="filter-options">
                              {getUniqueProjects().map((project) => (
                                <label className="filter-option" key={project}>
                                  <input
                                    type="checkbox"
                                    className="filter-checkbox"
                                    checked={selectedProjects.includes(project)}
                                    onChange={() => {
                                      setSelectedProjects((prev) =>
                                        prev.includes(project)
                                          ? prev.filter((p) => p !== project)
                                          : [...prev, project]
                                      );
                                    }}
                                  />
                                  <span className="filter-label">
                                    {project}
                                    <span className="filter-count">
                                      ({countVehiclesByProject(project)})
                                    </span>
                                  </span>
                                </label>
                              ))}
                            </div>
                          </div>

                          {/* Vehicle type filter section */}
                          <div className="filter-section">
                            <div className="filter-section-header">
                              <span className="filter-section-title">
                                Vehicle Type
                              </span>
                              <button
                                className="select-all-btn"
                                onClick={() => {
                                  const allTypes = getUniqueVehicleTypes();
                                  setSelectedVehicleTypes(
                                    selectedVehicleTypes.length ===
                                      allTypes.length
                                      ? []
                                      : allTypes
                                  );
                                }}
                              >
                                {selectedVehicleTypes.length ===
                                getUniqueVehicleTypes().length
                                  ? "Unselect All"
                                  : "Select All"}
                              </button>
                            </div>

                            <div className="filter-options">
                              {getUniqueVehicleTypes().map((type) => (
                                <label className="filter-option" key={type}>
                                  <input
                                    type="checkbox"
                                    className="filter-checkbox"
                                    checked={selectedVehicleTypes.includes(
                                      type
                                    )}
                                    onChange={() => {
                                      setSelectedVehicleTypes((prev) =>
                                        prev.includes(type)
                                          ? prev.filter((t) => t !== type)
                                          : [...prev, type]
                                      );
                                    }}
                                  />
                                  <span className="filter-label">
                                    {type}
                                    <span className="filter-count">
                                      ({countVehiclesByType(type)})
                                    </span>
                                  </span>
                                </label>
                              ))}
                            </div>
                          </div>

                          {/* Chassis number filter section */}
                          <div className="filter-section">
                            <div className="filter-section-header">
                              <span className="filter-section-title">
                                Chassis Number
                              </span>
                              <button
                                className="select-all-btn"
                                onClick={() => {
                                  const allChassisNumbers =
                                    getUniqueChassisNumbers();
                                  setSelectedChassisNumbers(
                                    selectedChassisNumbers.length ===
                                      allChassisNumbers.length
                                      ? []
                                      : allChassisNumbers
                                  );
                                }}
                              >
                                {selectedChassisNumbers.length ===
                                getUniqueChassisNumbers().length
                                  ? "Unselect All"
                                  : "Select All"}
                              </button>
                            </div>

                            <div className="filter-options">
                              {getUniqueChassisNumbers().map(
                                (chassisNumber) => (
                                  <label
                                    className="filter-option"
                                    key={chassisNumber}
                                  >
                                    <input
                                      type="checkbox"
                                      className="filter-checkbox"
                                      checked={selectedChassisNumbers.includes(
                                        chassisNumber
                                      )}
                                      onChange={() => {
                                        setSelectedChassisNumbers((prev) =>
                                          prev.includes(chassisNumber)
                                            ? prev.filter(
                                                (c) => c !== chassisNumber
                                              )
                                            : [...prev, chassisNumber]
                                        );
                                      }}
                                    />
                                    <span className="filter-label">
                                      {chassisNumber}
                                      <span className="filter-count">
                                        ({countVehiclesByChassis(chassisNumber)}
                                        )
                                      </span>
                                    </span>
                                  </label>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <IconButton
                onClick={handleMenuClick}
                aria-label="more actions"
                aria-controls={openMenu ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? "true" : undefined}
                sx={{
                  backgroundColor: "white",
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  color: "#333",
                  "&:hover": {
                    borderColor: "#333",
                    backgroundColor: "#fff6da",
                  },
                }}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="action-menu"
                anchorEl={menuAnchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "more-button",
                }}
                PaperProps={{
                  elevation: 3,
                  sx: {
                    borderRadius: "12px",
                    minWidth: "220px",
                    mt: 1,
                    overflow: "visible",
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 18,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    setRecalculateDialogOpen(true);
                  }}
                >
                  <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Recalculate</ListItemText>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    let data;
                    let tableName;

                    switch (activeTab) {
                      case "daily":
                        // Create daily report data directly here
                        const dailyData = [];

                        if (firmData) {
                          Object.keys(firmData).forEach((projectId) => {
                            const projectData = projects.find(
                              (p) => p.projectID === projectId
                            );
                            const projectName = projectData
                              ? projectData.projectName
                              : "--";

                            const vehicleMovements =
                              firmData[projectId]?.vehicleMovementRecords || {};

                            Object.entries(vehicleMovements).forEach(
                              ([timestamp, movement]) => {
                                const date = new Date(parseInt(timestamp));

                                if (date >= startDate && date <= endDate) {
                                  const hours = parseFloat(movement.hours) || 0;
                                  const meetsTimeFilter =
                                    timeFilter === "all"
                                      ? true
                                      : timeFilter === "< 8 hours"
                                      ? hours < 8
                                      : false;

                                  if (meetsTimeFilter) {
                                    const dieselConsumed =
                                      parseFloat(movement.quantity) || 0;
                                    const matchingVehicle = vehiclesData.find(
                                      (v) => v.tag === movement.tag
                                    );
                                    dailyData.push({
                                      projectName: projectName,
                                      by: movement.by || "--",
                                      date: date,
                                      type:
                                        matchingVehicle?.vehicleType || "--",
                                      number:
                                        matchingVehicle?.vehicleNumber || "--",
                                      chassisNumber:
                                        matchingVehicle?.chassisNumber || "--",
                                      startReading:
                                        movement.startReading || "--",
                                      endReading: movement.endReading || "--",
                                      hours: movement.hours || "--",
                                      engine2StartReading:
                                        movement.engine2StartReading || "--",
                                      engine2EndReading:
                                        movement.engine2EndReading || "--",
                                      engine2Hours:
                                        movement.engine2Hours || "--",
                                      kmsStartReading:
                                        movement.kmsStartReading || "--",
                                      kmsEndReading:
                                        movement.kmsEndReading || "--",
                                      kmsTravelled:
                                        movement.kmsTravelled || "--",
                                      fuelConsumed: dieselConsumed.toFixed(2),
                                      amount: movement.amount || "--",
                                      totalAmount: movement.amount
                                        ? (
                                            dieselConsumed * movement.amount
                                          ).toFixed(2)
                                        : "--",
                                      purpose: movement.purpose || "--",
                                      quantity: movement.quantity || "--",
                                    });
                                  }
                                }
                              }
                            );
                          });
                        }

                        // Sort by date descending
                        dailyData.sort((a, b) => b.date - a.date);

                        // Add date filter info to each entry
                        dailyData.forEach((entry) => {
                          entry.isDateFilterActive = true;
                          entry.startDate = startDate;
                          entry.endDate = endDate;
                        });

                        data = filterData(dailyData);
                        tableName = "Daily Vehicle Report";
                        break;

                      case "vehicle":
                        // Process vehicle data with date filtering applied
                        const isDateFilterActive = startDate && endDate;

                        // Create processed data with all necessary metrics calculated
                        const processedVehicleData = vehiclesData.map(
                          (item) => {
                            // Calculate date-filtered metrics if date filtering is active
                            const metrics = isDateFilterActive
                              ? calculateDateFilteredMetrics(
                                  item,
                                  startDate,
                                  endDate
                                )
                              : item;

                            // Store date filter information in the data
                            const dateFilterInfo = {
                              isDateFilterActive: isDateFilterActive,
                              startDate: startDate,
                              endDate: endDate,
                            };

                            // Calculate mileage (L/hr)
                            let mileage = "--";
                            const totalDieselConsumed = isDateFilterActive
                              ? parseFloat(metrics.totalDieselConsumed)
                              : parseFloat(item.totalDieselConsumed);
                            const totalHoursWorked = isDateFilterActive
                              ? parseFloat(metrics.totalHoursWorked)
                              : parseFloat(item.totalHoursWorked);

                            if (
                              !isNaN(totalDieselConsumed) &&
                              !isNaN(totalHoursWorked) &&
                              totalHoursWorked > 0
                            ) {
                              mileage = (
                                totalDieselConsumed / totalHoursWorked
                              ).toFixed(2);
                            }

                            // Get expected mileage
                            const expectedMileage = getExpectedMileage(
                              item.model
                            );

                            // Calculate efficiency ratio
                            const efficiencyRatio = calculateEfficiencyRatio(
                              mileage,
                              expectedMileage
                            ); // Create a copy of the original item for reference (to be used for cumulative metrics)
                            const originalItem = { ...item };

                            return {
                              ...item,
                              // Include date filter information
                              isDateFilterActive:
                                dateFilterInfo.isDateFilterActive,
                              startDate: dateFilterInfo.startDate,
                              endDate: dateFilterInfo.endDate,
                              // For export, use the same processed values that the table displays for filtered metrics
                              mileage: mileage,
                              expectedMileage: expectedMileage,
                              efficiencyRatio: efficiencyRatio,
                              totalKilometers: isDateFilterActive
                                ? metrics.totalKilometers
                                : item.totalKilometers ||
                                  item.kmsTravelled ||
                                  0,
                              totalDieselConsumed: isDateFilterActive
                                ? metrics.totalDieselConsumed
                                : item.totalDieselConsumed || 0,
                              amount: isDateFilterActive
                                ? metrics.amount
                                : item.amount || 0,
                              totalHoursWorked: isDateFilterActive
                                ? metrics.totalHoursWorked
                                : item.totalHoursWorked || 0,
                              engine2: {
                                ...item.engine2,
                                totalHoursWorked: isDateFilterActive
                                  ? metrics.engine2?.totalHoursWorked || 0
                                  : item.engine2?.totalHoursWorked || 0,
                              },
                              // Store the original unfiltered values for cumulative metrics
                              originalData: originalItem,
                            };
                          }
                        );

                        data = filterData(processedVehicleData);
                        tableName = "Vehicle Information";
                        break;

                      case "service":
                        // Add date filter info to maintenance data
                        const maintenanceDataWithFilters = maintenanceData.map(
                          (entry) => ({
                            ...entry,
                            isDateFilterActive: false, // Service data doesn't use date filtering
                          })
                        );
                        data = filterData(maintenanceDataWithFilters);
                        tableName = "Service Schedule";
                        break;
                    }

                    exportToExcel(data, tableName, firmData);
                  }}
                >
                  <ListItemIcon>
                    <FileDownloadIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Export to Excel</ListItemText>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    setIsAddModalOpen(true);
                  }}
                >
                  <ListItemIcon>
                    <AddCircleOutlineIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Add Asset</ListItemText>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    setIsConsumptionModalOpen(true);
                  }}
                >
                  <ListItemIcon>
                    <DirectionsCarIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Add Usage</ListItemText>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    history.push("/EntryLogs");
                  }}
                >
                  <ListItemIcon>
                    <AssignmentIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Entry Logs</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </div>

          <div className="controls-section">
            <div className="search-row">
              <div className="search-wrapper">
                <input
                  type="text"
                  placeholder="Search here..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          {(selectedProjects.length > 0 ||
            selectedVehicleTypes.length > 0 ||
            selectedChassisNumbers.length > 0) && (
            <div className="active-filters">
              {selectedProjects.map((project) => (
                <div key={project} className="filter-tag">
                  {project}
                  <button
                    onClick={() =>
                      setSelectedProjects((prev) =>
                        prev.filter((p) => p !== project)
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
              {selectedVehicleTypes.map((type) => (
                <div key={type} className="filter-tag">
                  {type}
                  <button
                    onClick={() =>
                      setSelectedVehicleTypes((prev) =>
                        prev.filter((t) => t !== type)
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          {activeTab === "daily" && renderDailyReportTable()}
          {activeTab === "vehicle" && renderVehicleInformationTable()}
          {activeTab === "service" && renderServiceScheduleTable()}
          {renderMaintenanceModal()}
          {breakdownModalOpen && (
            <BreakdownModal
              breakdownData={selectedBreakdowns}
              onClose={() => {
                setBreakdownModalOpen(false);
                setSelectedBreakdowns(null);
              }}
            />
          )}
        </>
      )}
      <Dialog
        open={isAddModalOpen}
        onClose={() => {
          setIsAddModalOpen(false);
          setSelectedVehicle(null);
        }}
        maxWidth="lg"
        fullWidth
      >
        <VehicleForm
          vehicle={selectedVehicle}
          onSubmit={handleSubmit} // Pass the submit handler here
          projects={projects}
          mode={isAddModalOpen ? "add" : "edit"}
          loading={actionLoading}
          onClose={() => {
            setIsAddModalOpen(false);
            setIsEditModalOpen(false);
            setSelectedVehicle(null);
          }}
          firmId={firmId}
          vehicleTypes={getExistingVehicleTypes()}
        />
      </Dialog>

      {/* Transfer Vehicle Modal */}
      <Dialog
        open={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedVehicle(null);
        }}
        maxWidth="lg"
        fullWidth
      >
        <VehicleForm
          vehicle={selectedVehicle}
          onSubmit={handleEdit} // This will be called when form is submitted
          projects={projects}
          mode="edit" // Make sure this is set to "edit"
          loading={actionLoading}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedVehicle(null);
          }}
          firmId={firmId}
          vehicleTypes={getExistingVehicleTypes()}
        />
      </Dialog>
      {/* Recalculation Confirmation Dialog */}
      <Dialog
        open={recalculateDialogOpen}
        onClose={() => setRecalculateDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 12,
            padding: 8,
          },
        }}
      >
        <Box sx={{ position: "relative", p: 2 }}>
          <IconButton
            size="small"
            onClick={() => setRecalculateDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </IconButton>

          <Typography
            variant="h6"
            component="h2"
            sx={{ mb: 2, color: "#333", fontWeight: 600 }}
          >
            Recalculate Vehicle Metrics
          </Typography>

          <Typography variant="body1" sx={{ mb: 3 }}>
            This action will analyze all vehicle movement records to
            recalculate:
          </Typography>

          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: 2,
              p: 2,
              mb: 3,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              • Total hours worked
            </Typography>
            <Typography
              variant="body1"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              • Total fuel consumed
            </Typography>
            <Typography
              variant="body1"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              • Total kilometers traveled
            </Typography>
            <Typography
              variant="body1"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              • Engine 2 metrics (if applicable)
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "#fff8e5",
              border: "1px solid #ffd54f",
              borderRadius: 2,
              p: 2,
              mb: 3,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#bf8c12", fontWeight: 500 }}
            >
              <strong>Note:</strong> This process will update all vehicle data
              in the database. It ensures that your reports display accurate
              metrics based on all recorded vehicle movements. The operation
              cannot be undone.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              onClick={() => setRecalculateDialogOpen(false)}
              variant="outlined"
              sx={{
                borderRadius: 2,
                borderColor: "#ccc",
                color: "#666",
                "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setRecalculateDialogOpen(false);
                recalculateVehicleMetrics();
              }}
              variant="contained"
              sx={{
                backgroundColor: "#fdd34d",
                color: "black",
                borderRadius: 2,
                fontWeight: 500,
                "&:hover": { backgroundColor: "#fcc520" },
              }}
            >
              Proceed with Recalculation
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* Transfer Modal */}
      {isTransferModalOpen && (
        <TransferVehicle
          open={isTransferModalOpen}
          onClose={() => setIsTransferModalOpen(false)}
          vehicle={selectedVehicle}
          projects={projects}
          currentProject={selectedVehicle?.projectName}
          onTransfer={handleTransfer}
          loading={actionLoading}
        />
      )}

      {/* Add this near your other modals */}
      {isConsumptionModalOpen && (
        <ConsumptionModal
          open={isConsumptionModalOpen}
          onClose={() => setIsConsumptionModalOpen(false)}
          onSubmit={handleAddConsumption}
          onDelete={handleDeleteConsumption}
          onEdit={handleEditConsumption}
          projects={projects}
          vehicles={vehiclesData}
          firmData={firmData}
          loading={actionLoading}
          consumptionHistoryData={consumptionHistoryData}
        />
      )}

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default DrawerTemplate(Vehicles);
